/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/assets/js/common.js":
/*!*********************************!*\
  !*** ./src/assets/js/common.js ***!
  \*********************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//基础操作
//以及提供了一些全局的方法，比如$.CN，用于处理类名的前缀。比如showPopUp，用于弹窗显示与关闭后的相关处理。还有一些统一的样式处理，如上浮效果等。

window.debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
window.clamp = function _clamp(t, e, r) {
  return r < t ? t : e < r ? e : r;
};
window.loadCSS = function loadCSS(url, callback) {
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = url;

  // 确保CSS加载完成后执行回调
  link.onload = function () {
    if (callback) callback();
  };
  document.head.appendChild(link);
};
window.loadScript = function loadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;

  // 确保脚本加载完成后执行回调
  script.onload = function () {
    if (callback) callback();
  };
  document.head.appendChild(script);
};
/* harmony default export */ __webpack_exports__["default"] = ((function () {
  var defaultSp = function defaultSp(e) {
    return !(e.startsWith(".swiper") || ".purchase-sales-channel-btn" === e);
  };
  (function ($) {
    $.extend({
      CN: function CN(str) {
        var sp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSp;
        var t = function t(_t) {
            return !sp && _t.includes("#") ? _t : _t.startsWith(".") || _t.includes(".") ? _t.split(".").join(".".concat("Qrevo_Edge_Series_")) : _t;
          },
          r = function r(e) {
            return "" === e ? null : t(e);
          };
        return str.split(",").map(function (e) {
          return e.trim().split(" ").map(function (e) {
            var ee = e.replace(/(\.[^.]*)/g, function (v) {
              return (typeof sp === "function" ? sp(v) : sp) ? r(v) : v;
            });
            return ee;
          }).join(" ");
        }).join(", ");

        // return str.replace(/(\..*)?/g, function (v) {
        //   if((v.startsWith("swiper") || "purchase-sales-channel-btn" === v))
        //   return v.replace(/\./g, '.' + PREFIXER)
        // })
      }
    });
  })($);

  ///一些直接的全局方法

  var currentPosition = 0;
  window.addEventListener("scroll", function (e) {
    if (window.scrollY != 0) {
      currentPosition = window.scrollY;
    }

    //在开发模式下，记录下当前的滚动位置
    if (false) {}
  });
  //在开发模式下，下次刷新时，恢复上次的滚动位置
  if (false) { var lastScroll; }

  //新品订阅按钮
  $("#product_subscription_b").on("click", function () {
    $("#subscribe-modal").css({
      display: "block"
    });
  });
  window.isVisible = function isVisible(element) {
    if (!element) {
      return false;
    }
    if (element == document.documentElement) {
      return true;
    }
    var style = window.getComputedStyle(element);
    if (style.display === "none" || style.visibility === "hidden") {
      return false;
    }
    return !element.parentElement || isVisible(element.parentElement);
  };

  // 处理出现弹窗显示时的滚动位置的处理。记录下来，在关闭时，还要恢复滚动位置
  window.isPopupShown = false;
  window.afterPopupShown = function afterPopupShown() {
    //更新一下body的css变量--scroll-padding为滚动条的宽。另外还多加了5px
    $(document.documentElement).css("--scroll-padding", window.innerWidth - document.body.clientWidth + 5 + "px");
    $("body").css({
      top: "-" + currentPosition + "px"
    }).addClass("".concat("Qrevo_Edge_Series_", "has-popup"));
    //特别处理一下sideBtn
    $("#sideBtn").hide();
    window.isPopupShown = true;
  };
  window.afterPopupHidden = function afterPopupHidden() {
    var lastPosition = Number($("body").css("top").replace("px", "")) * -1;
    // $(document.documentElement).css("--scroll-padding", "0px");
    document.documentElement.style.setProperty("--scroll-padding", "0px");
    $("body").removeClass("".concat("Qrevo_Edge_Series_", "has-popup")).css({
      top: "0px"
    });
    window.scrollTo(0, lastPosition);
    //特别处理一下sideBtn
    $("#sideBtn").show();
    window.isPopupShown = false;
  };

  //这个方法是用来扩展gsap的tween里的onUpdate方法，用来实现一个动画的方向的追踪,以实现类似onReverse,onForward的效果
  window.trackDirection = function trackDirection(value) {
    _typeof(value) !== "object" && (value = {
      onUpdate: value
    });
    var prevTime = 0,
      prevReversed = false,
      anim = value.eventCallback ? value : value.animation,
      onUpdate = value.onUpdate,
      onToggle = value.onToggle;
    return anim ? anim.eventCallback("onUpdate", trackDirection({
      onUpdate: onUpdate,
      onToggle: onToggle
    })) : function () {
      var time = this.totalTime(),
        reversed = time < prevTime;
      this.direction = reversed ? -1 : 1;
      if (reversed !== prevReversed) {
        onToggle && onToggle.call(this, this.direction);
        prevReversed = reversed;
      }
      prevTime = time;
      onUpdate && onUpdate.call(this, this.direction);
    };
  };

  //用于DEBUG SCROLLTRIGGER的开关变量
  window.markers = false;
  function basics() {
    // topbar兼容
    if ($(".ad-bar").length > 0) {
      $($.CN(".container")).css({
        "margin-top": "110px"
      });
    }

    //新品订阅按钮
    $("#product_subscription_b").on("click", function () {
      $("#subscribe-modal").css({
        display: "block"
      });
    });
    var isSafari = navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && navigator.userAgent && navigator.userAgent.indexOf("CriOS") == -1 && navigator.userAgent.indexOf("FxiOS") == -1;
    if (isSafari) {
      $(document.body).addClass("".concat("Qrevo_Edge_Series_", "issafari"));
    }
    function getCssVarValue(cssVar) {
      // 创建一个临时元素
      var tempElement = document.createElement("div");

      // 将CSS变量应用到临时元素
      tempElement.style.width = "var(".concat(cssVar, ")");

      // 将临时元素添加到DOM
      document.body.appendChild(tempElement);

      // 获取计算后的px值
      var computedValue = getComputedStyle(tempElement).width;

      // 从DOM中移除临时元素
      document.body.removeChild(tempElement);

      // console.log(computedValue);
      return Number(computedValue.replace("px", ""));
    }
    window["$"] = $;

    //resize时要更新一些全局变量
    window.onresize = function () {
      // window.bodyFontSize = Number($(document.body).css("--body-font-size"));

      document.documentElement.style.setProperty("--full-view-height", "".concat(window.innerHeight, "px"));
      var bodyStyle = getComputedStyle(document.body);
      window.bodyFontSize = Number(bodyStyle.getPropertyValue("--body-font-size"));
      window.contentWidth1 = getCssVarValue("--content-width-1");
      window.contentWidth2 = getCssVarValue("--content-width-2");
      window.contentWidth3 = getCssVarValue("--content-width-3");
      window.contentPadding1 = getCssVarValue("--content-padding-1");
      window.contentPadding2 = getCssVarValue("--content-padding-2");
      window.contentPadding3 = getCssVarValue("--content-padding-3");
      window.contentNegetivePadding1 = getCssVarValue("--content-negetive-padding-1");
      window.contentNegetivePadding2 = getCssVarValue("--content-negetive-padding-2");
      window.contentNegetivePadding3 = getCssVarValue("--content-negetive-padding-3");

      // window.pageTopPadding = Number(
      //   ($(document.body).css("--page-top-padding") || "0").replace("px", "")
      // ); //bodyFontSize * 1.53;

      window.pageTopPadding = Number((bodyStyle.getPropertyValue("--page-top-padding") || "0").replace("px", ""));
      window.sectionMinHeight = window.innerHeight; //Math.max(window.innerHeight, 600);
      window.sectionMinHeightWithoutTop = window.sectionMinHeight - window.pageTopPadding;
    };
    window.onresize();

    //为SCROLLTRIGGER注册一个tags以及onTag的功能
    var originalCreate = ScrollTrigger.create;
    ScrollTrigger.create = function (config) {
      if (config.tags) {
        // 初始化每个 tag 的状态
        var tagsState = config.tags.map(function (tag) {
          return _objectSpread(_objectSpread({}, typeof tag == "number" ? {
            progress: tag,
            tag: tag
          } : tag), {}, {
            triggered: false
          });
        });
        this._lastProgress = 0;

        // 原始 onUpdate 回调
        var originalOnUpdate = config.onUpdate;

        // 扩展 onUpdate 回调
        config.onUpdate = function (self) {
          var progress = self.progress;
          var direction = progress > self._lastProgress ? "forward" : "backward";
          tagsState.forEach(function (tag) {
            if (direction === "forward" && !tag.triggered && progress >= tag.progress || direction === "backward" && tag.triggered && progress <= tag.progress) {
              // 触发 onTag 回调
              if (config.onTag) {
                config.onTag({
                  tag: tag.tag,
                  progress: tag.progress,
                  direction: direction
                });
              }
              // 更新 tag 状态
              tag.triggered = !tag.triggered;
            }
          });

          // 调用原始 onUpdate 回调
          if (originalOnUpdate) {
            originalOnUpdate(self);
          }
          self._lastProgress = progress;
        };
      }

      // 调用原始 ScrollTrigger.create 方法
      return originalCreate(config);
    };

    //处理统一的上浮效果

    $("".concat($.CN(".fade-out"))).each(function () {
      ScrollTrigger.create({
        trigger: $(this),
        start: "top bottom-=" + (!isPhone ? "15%" : "5%"),
        end: "top+=" + (isPhone ? 100 : 150) + " bottom-=" + (!isPhone ? "15%" : "5%"),
        onEnter: function onEnter(st) {
          gsap.fromTo($(st.trigger), {
            y: 40,
            opacity: 0
          }, {
            y: 0,
            opacity: 1,
            ease: "sine.inOut",
            immediateRender: true
          });
        },
        markers: markers,
        invalidateOnRefresh: true,
        scrub: 0.5
      });
    });

    //统一处理一下video的懒加载效果
    $("video[data-src]").each(function () {
      var video = $(this).get(0);
      var videoSrc = video.getAttribute("data-src");
      // video.load();
      // video.removeAttribute("data-src");
      var self = this;
      ScrollTrigger.create({
        trigger: $(this),
        start: "top-=" + (isPhone ? 200 : 350) + " bottom",
        end: "bottom+=" + (isPhone ? 200 : 350) + " top",
        onEnter: function onEnter(st) {
          if (isVisible(video)) {
            video.src = videoSrc;
            video.onload = function () {
              ScrollTrigger.refresh();
            };
            try {
              video.play();
            } catch (e) {}
          }
        },
        onEnterBack: function onEnterBack(st) {
          if (isVisible(video)) {
            video.src = videoSrc;
            video.onload = function () {
              ScrollTrigger.refresh();
            };
            try {
              video.play();
            } catch (e) {}
          }
        },
        once: true,
        markers: markers,
        invalidateOnRefresh: true,
        scrub: false
      });
    });

    //统一处理一下img的懒加载效果
    $("img[data-src]").each(function () {
      var img = $(this).get(0);
      var imgSrc = img.getAttribute("data-src");
      // video.load();
      // video.removeAttribute("data-src");
      var self = this;
      ScrollTrigger.create({
        trigger: $(self),
        start: "top-=" + (isPhone ? 200 : 350) + " bottom",
        end: "bottom+=" + (isPhone ? 200 : 350) + " top",
        onEnter: function onEnter(st) {
          if (isVisible(img)) img.src = imgSrc;
          img.onload = function () {
            ScrollTrigger.refresh();
          };
        },
        onEnterBack: function onEnterBack(st) {
          if (isVisible(img)) img.src = imgSrc;
          img.onload = function () {
            ScrollTrigger.refresh();
          };
        },
        id: $(self).data("test"),
        once: true,
        markers: !!$(self).data("test"),
        invalidateOnRefresh: true,
        scrub: false
      });
    });

    // //统一处理leave-scale-down 的效果
    // setTimeout(() => {
    //   $(`${$.CN(".leave-scale-down")}`).each(function () {
    //     let self = this;
    //     ScrollTrigger.create({
    //       trigger: $(this),
    //       onEnter: function (st) {
    //         gsap.fromTo(
    //           $(self),
    //           0.5,
    //           {
    //             scale: 1.05,
    //           },
    //           {
    //             scale: 1,
    //             ease: "sine.inOut",
    //           }
    //         );
    //       },
    //       onLeaveBack: function (st) {
    //         gsap.fromTo(
    //           $(self),
    //           0.5,
    //           {
    //             scale: 1,
    //           },
    //           {
    //             scale: 1.05,
    //             ease: "sine.inOut",
    //           }
    //         );
    //       },
    //       onEnterBack: function (st) {
    //         gsap.fromTo(
    //           $(self),
    //           0.5,
    //           {
    //             scale: 1.05,
    //           },
    //           {
    //             scale: 1,
    //             ease: "sine.inOut",
    //           }
    //         );
    //       },
    //       onLeave: function (st) {
    //         gsap.fromTo(
    //           $(self),
    //           0.5,
    //           {
    //             scale: 1,
    //           },
    //           {
    //             scale: 1.05,
    //             ease: "sine.inOut",
    //           }
    //         );
    //       },
    //       start: "top 80%",
    //       end: "bottom 20%",
    //       markers,
    //       invalidateOnRefresh: true,
    //       scrub: 0.5,
    //     });
    //   });
    // }, 100);

    //处理统一的图片的缩小效果

    // //延时500ms，以避免因为layout的问题导致位置计算不正确的问题
    // setTimeout(() => {
    //   $($.CN(".scale-down")).each(function () {
    //     let target = this;
    //     $(this).css({
    //       transformOrigin: "center center",
    //       scale: 1.05,
    //       opacity: 0,
    //     });

    //     ScrollTrigger.create({
    //       onEnter: function (st) {
    //         gsap
    //           .timeline()
    //           .set(
    //             {},
    //             {
    //               onComplete: function () {
    //                 $(target).css({
    //                   transformOrigin: "center center",
    //                   scale: 1.05,
    //                   opacity: 0,
    //                 });
    //               },
    //             }
    //           )
    //           .add([
    //             gsap.to($(target), 1.0, {
    //               ease: "sine.out",
    //               scale: 1,
    //             }),
    //             gsap.to($(target), 0.5, {
    //               ease: "sine.out",
    //               opacity: 1,
    //             }),
    //           ]);
    //       },
    //       trigger: $(this),
    //       start: "top bottom-=" + (!isPhone ? "25%" : "50"),
    //       end: "top bottom-=" + (!isPhone ? "25%" : "50"),
    //       markers,
    //       once: true,
    //       // invalidateOnRefresh: true,
    //       scrub: true,
    //     });

    //     // gsap.fromTo($(this), {
    //     //   scale: 1.1,
    //     // }, {
    //     //   scale: 1,
    //     //   ease: "sine.inOut",
    //     //   immediateRender: true,
    //     //   scrollTrigger: {
    //     //     trigger: $(this),
    //     //     start: "top bottom-="+(!isPhone?"15%":"5%"),
    //     //     end: "top+=" + (isPhone ? 100 : 150) + " bottom-="+(!isPhone?"15%":"5%"),
    //     //     markers,
    //     //     invalidateOnRefresh: true,
    //     //     scrub: false,
    //     //   }
    //     // })
    //   });
    // }, 100);

    //处理所有的红色装饰横条。注意要延迟添加，因为有些父容器有被PIN住，要保证在那之后添加
    setTimeout(function () {
      $($.CN(".small-bar")).each(function () {
        var self = this;
        ScrollTrigger.create({
          trigger: self,
          start: "bottom bottom-=15%",
          end: "bottom bottom-=15%",
          //   markers: true,
          onEnter: function onEnter(st) {
            $(st.trigger).addClass("".concat("Qrevo_Edge_Series_", "active"));
          },
          onLeaveBack: function onLeaveBack(st) {
            $(st.trigger).removeClass("".concat("Qrevo_Edge_Series_", "active"));
          },
          //   id: $(self).data("id") || "small-bar",
          //   markers: true,
          invalidateOnRefresh: true,
          scrub: 0.5
        });
      });
    }, 500);

    //统一处理一下img-holder.offset-view里的图片，在滚动的时候，有一个相对错位的效果
    setTimeout(function () {
      $($.CN(".img-holder.offset-view")).each(function () {
        var self = this;
        var tl = gsap.timeline();
        tl.add(gsap.fromTo($(self).find("img"), {
          scale: 1.1,
          y: "-4.9%"
        }, {
          scale: 1.1,
          y: "4.9%",
          ease: "sine.inOut",
          immediateRender: true,
          duration: 1
        }));
        ScrollTrigger.create({
          animation: tl,
          trigger: self,
          start: "top bottom-=0%",
          end: "bottom top+=0%",
          markers: markers,
          invalidateOnRefresh: true,
          scrub: 1
        });
      });
    }, 100);

    //统一处理中间过滤屏的PIN效果
    // pin-section
    $($.CN(".pin-section")).each(function () {
      var self = this;
      ScrollTrigger.create({
        trigger: self,
        start: function start() {
          return "top top+=" + (window.innerHeight * 0.5 + $(self).height() * 0.5);
        },
        end: "bottom top-=100%",
        pin: true,
        pinSpacing: false,
        scrub: true,
        markers: markers,
        invalidateOnRefresh: true
      });
    });

    //因为图片和视频的加载会改变布局，所以监听所有的video和img的onload事件，然后执行一下ScrollTrigger.refresh()。同时加上防抖处理，尽量不要频繁调用

    // var refreshScrollTrigger = debounce(function () {
    //   ScrollTrigger.refresh();
    //   // console.log('ScrollTrigger.refresh()')
    // }, 500);

    // $("video").on("load", refreshScrollTrigger);
    // $("img").on("load", refreshScrollTrigger);

    // const updateScrollTrigger = (entries) => {
    //   // for (let entry of entries) {
    //   //   console.log('Size of', entry.target, 'has changed!');
    //   // }
    //   ScrollTrigger.refresh(true);
    // };

    // // Watch for changes in the size of the dynamic height element (#resizeableElement)
    // const resizeObserver = new ResizeObserver(updateScrollTrigger);

    // $($.CN(".section")).each(function () {
    //   resizeObserver.observe($(this).get(0));
    // });

    // const lenis = new Lenis({ duration: 0.5 });

    // // lenis.on("scroll", (e) => {
    // //   console.log(e);
    // // });

    // lenis.on("scroll", ScrollTrigger.update);

    // gsap.ticker.add((time) => {
    //   lenis.raf(time * 500);
    // });

    // gsap.ticker.lagSmoothing(0);
  }

  //   //加载完后再强制刷新一下ScrollTrigger
  document.addEventListener("DOMContentLoaded", function (e) {
    ScrollTrigger.refresh();
  });
  $(basics);
})());

/***/ }),

/***/ "./src/i18n/index.js":
/*!***************************!*\
  !*** ./src/i18n/index.js ***!
  \***************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/i18n/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");
// 多语言的个性化处理
//会根据当前的语言，条件编译不同的语言模块。
//针对某语言的样式处理放到具体的语言模块中再引入。

//如果是生产环境，直接引入对应的语言模块。否则就根据运行时的语言动态引入对应的语言模块。
if (true) {
  if (false) {} else if (false) {} else if (false) {} else if (false) {} else if (false) {} else if (false) {} else if (false) {} else if (false) {} else if (false) {} else if (false) {} else if (false) {}
} else {}
$(function () {
  window.dispatchEvent(new Event("languagechange"));
});

/***/ }),

/***/ "./src/sections/index.js":
/*!*******************************!*\
  !*** ./src/sections/index.js ***!
  \*******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _section1__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./section1 */ "./src/sections/section1/index.js");
/* harmony import */ var _section2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./section2 */ "./src/sections/section2/index.js");
/* harmony import */ var _section3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./section3 */ "./src/sections/section3/index.js");
/* harmony import */ var _section5__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./section5 */ "./src/sections/section5/index.js");
/* harmony import */ var _section7__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./section7 */ "./src/sections/section7/index.js");
/* harmony import */ var _section8__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./section8 */ "./src/sections/section8/index.js");
/* harmony import */ var _section10__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./section10 */ "./src/sections/section10/index.js");
/* harmony import */ var _section11__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./section11 */ "./src/sections/section11/index.js");
/* harmony import */ var _section12__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./section12 */ "./src/sections/section12/index.js");
/* harmony import */ var _section13__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./section13 */ "./src/sections/section13/index.js");
/* harmony import */ var _section14__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./section14 */ "./src/sections/section14/index.js");
/* harmony import */ var _section15__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./section15 */ "./src/sections/section15/index.js");
/* harmony import */ var _section16__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./section16 */ "./src/sections/section16/index.js");
/* harmony import */ var _section16_expand__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./section16-expand */ "./src/sections/section16-expand/index.js");
/* harmony import */ var _section17__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./section17 */ "./src/sections/section17/index.js");
/* harmony import */ var _section18__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./section18 */ "./src/sections/section18/index.js");
/* harmony import */ var _section19__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./section19 */ "./src/sections/section19/index.js");
/* harmony import */ var _section20__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./section20 */ "./src/sections/section20/index.js");
/* harmony import */ var _section21__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./section21 */ "./src/sections/section21/index.js");
/* harmony import */ var _section23__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./section23 */ "./src/sections/section23/index.js");
/* harmony import */ var _section24__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./section24 */ "./src/sections/section24/index.js");
/* harmony import */ var _section25__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./section25 */ "./src/sections/section25/index.js");
/* harmony import */ var _section26__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./section26 */ "./src/sections/section26/index.js");
/* harmony import */ var _section27__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./section27 */ "./src/sections/section27/index.js");
/* harmony import */ var _section28__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./section28 */ "./src/sections/section28/index.js");
/* harmony import */ var _section29__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./section29 */ "./src/sections/section29/index.js");
/* harmony import */ var _section35__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./section35 */ "./src/sections/section35/index.js");



// import "./section4";



// import './section9'













// import "./section22";







//相册

// import './section36'
//尺寸
// import './section34'
//STAY TUNED IN!
// import './section37'
//COMAPARE
// import './section38'
//NOTES
// import './section39'

// import './shared'

/***/ }),

/***/ "./src/sections/section1/index.js":
/*!****************************************!*\
  !*** ./src/sections/section1/index.js ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section1/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");
/**
 * 第一部分
 */

$(function () {});

/***/ }),

/***/ "./src/sections/section10/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section10/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section10/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section11/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section11/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section11/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section12/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section12/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section12/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section13/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section13/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section13/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section14/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section14/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section14/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  // window.st=null;

  $($.CN(".section-14 .tab")).click(function () {
    clickItem($(this).index(), true);
  });
  var clickItem = function clickItem(index, click) {
    // if(click){

    //   //从13屏的底部+cards-holder上半截的位置算起
    //   var startScroll=$($.CN(".section-13")).offset().top+$($.CN(".section-13")).outerHeight()+($($.CN(".section-14 .cards-holder")).offset().top-$($.CN(".section-14")).offset().top);

    //   var h=$($.CN(".section-14 .cards-holder")).outerHeight(true)
    //   var th=window.innerHeight-h;
    //   // var offset=$($.CN(".section-14 .cards-holder")).offset().top-th;
    //   var offset=startScroll-th;
    //   console.log(startScroll)

    //   var cs=window.scrollY;
    //   var ts=offset+window.innerHeight/3*index
    //   ts+=ts>cs?5:-5

    //   window.scrollTo({top:ts, behavior: 'smooth'})

    // }
    // else{

    currentActiveItemIndex = index;
    $($.CN(".section-14 .tab")).eq(index).addClass("".concat("Qrevo_Edge_Series_", "active")).siblings().removeClass("".concat("Qrevo_Edge_Series_", "active"));
    $($.CN(".section-14 .video-holder .video-item")).removeClass("".concat("Qrevo_Edge_Series_", "active"));
    $($.CN(".section-14 .video-holder .video-item")).eq(index).addClass("".concat("Qrevo_Edge_Series_", "active"));
    requestAnimationFrame(function () {
      //计算横向滚动的位置
      var s = 0;
      $($.CN(".section-14 .tab")).each(function (index, i) {
        if (index < currentActiveItemIndex) {
          s += $(i).outerWidth();
        }
        // s+=window.contentPadding3
      });
      $($.CN(".section-14 .tabs")).get(0).scrollTo({
        left: s,
        behavior: 'smooth'
      });

      // .scrollIntoView({
      //   behavior: 'smooth', // 滚动行为，'smooth' 表示平滑滚动
      //   block: 'nearest',  // 在 block 轴向上（纵向）最近的边缘对齐
      //   inline: 'start'    // 在 inline 轴向上（横向）开始对齐
      // })
    });
    startAutoNextItem();

    // }
  };
  if (isPhone) {
    $($.CN(".section-14 .tab")).eq(3).css('marginRight', window.innerWidth - $($.CN(".section-14 .tab")).eq(3).outerWidth() - 2 * window.contentPadding3);
  }
  var nextItemTimer;
  var currentActiveItemIndex = -1;
  var startAutoNextItem = function startAutoNextItem() {
    clearTimeout(nextItemTimer);
    nextItemTimer = setTimeout(nextItem, 5000);
  };
  var nextItem = function nextItem() {
    currentActiveItemIndex++;
    currentActiveItemIndex = currentActiveItemIndex % $($.CN(".section-14 .tab")).length;
    clickItem(currentActiveItemIndex);
  };
  ScrollTrigger.create({
    trigger: $.CN(".section-14 .tabs"),
    start: "bottom bottom-=15%",
    end: "bottom top",
    markers: markers,
    onEnter: function onEnter(st) {
      clickItem(0);
    },
    onEnterBack: function onEnterBack(st) {
      clickItem(currentActiveItemIndex);
    },
    onLeaveBack: function onLeaveBack() {
      clearTimeout(nextItemTimer);
    },
    onLeave: function onLeave() {
      clearTimeout(nextItemTimer);
    }
  });

  // setTimeout(() => {

  //  window.st= ScrollTrigger.create({
  //     tags: [0, 0.33, 0.66, 1],
  //     pin:$.CN(".section-14"),
  //     // pinSpacing: false,
  //     trigger: $.CN(".section-14 .cards-holder"),
  //     start: ()=>{
  //       var h=$($.CN(".section-14 .cards-holder")).outerHeight(true)
  //       return "top bottom-="+h
  //     },
  //     end: ()=>{
  //       var h=$($.CN(".section-14 .cards-holder")).outerHeight(true)
  //       return "top+="+window.innerHeight+" bottom-="+h
  //     },
  //     markers,
  //     onTag: (t) => {
  //       if (t.tag == 0) {
  //         if (t.direction == "backward") clickItem(0);
  //         // else clickItem(0);
  //       }
  //       else if (t.tag == 0.33) {
  //         if (t.direction == "forward") clickItem(1);
  //         else clickItem(1);
  //       }
  //       else if (t.tag == 0.66) {
  //         if (t.direction == "forward") clickItem(2);
  //         else clickItem(2);
  //       }
  //       else if (t.tag == 1) {
  //         if (t.direction == "forward") clickItem(3);
  //         else clickItem(3);
  //       }
  //     },
  //   });
  // }, 1000);
});

/***/ }),

/***/ "./src/sections/section15/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section15/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section15/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  //强制加载序列桢图片并打包
  //   require.context('../../assets/images/section-15', false, /dock_\d+\.jpg$/);

  if (!isPhone) {
    //   let quence15Pc = new Sequence({
    //     canvas: document.getElementById("s15canvas-pc"),
    //     imgLenth: 41,
    //     timeSpan: 70,
    //     // imgUrl: `https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/robo_q7_sixth_map`,
    //     // imgUrl: `${BASE_URL}files/${PREFIXER}s1ban_`, //或者
    //     imgUrl:`${BASE_URL}files/${PREFIXER}section-15_dock_`,
    //     imgtype:'.jpg',
    //     fillZeroLength:5,
    //     pictureCoefficient: 2,
    //     isFullscreen: false
    // });

    // ScrollTrigger.create({
    //   trigger:$.CN('.section-15'),
    //   start:'top top+=5%',
    //   end:'bottom top+=10%',
    //   pin:$.CN('.section-15 .out-img-container'),
    //   anticipatePin: 1,
    //   markers:true,
    //   scrub: 0.5,
    //   id:'s15-pin',
    // })

    var tl = gsap.timeline();
    tl.add([gsap.fromTo($.CN(".section-15 .bottom-part"), {
      duration: 1,
      opacity: 0
    }, {
      opacity: 1
    }), gsap.fromTo($.CN(".section-15 .bottom-part"), {
      duration: 4,
      height: 0
    }, {
      height: $($.CN(".section-15 .bottom-part-inside")).height(),
      onUpdate: function onUpdate() {
        //   quence15Pc.gotoAndStop(41*this.progress())
      }
    }), gsap.fromTo($.CN(".section-15"), {
      duration: 4,
      paddingBottom: window.bodyFontSize * 3
    }, {
      paddingBottom: window.bodyFontSize * 1
    })

    //   gsap.fromTo($.CN(".section-15 .video-holder"),{duration:4, top:0},{

    //     top:$($.CN(".section-15 .bottom-part-inside")).height()/2

    // }),

    // gsap.fromTo($.CN(".section-15"),{duration:4, paddingBottom:$($.CN(".section-15 .bottom-part-inside")).height()},{
    //     paddingBottom: 0
    // })
    ]);
    $($.CN(".section-15 .video-holder.hide-mobile canvas,.section-15 .video-holder.hide-mobile img")).css({
      "margin-top": $($.CN(".section-15 .top-part")).height() / 2,
      transform: "translateY(-50%)"
    });
    ScrollTrigger.create({
      animation: tl,
      trigger: $.CN(".section-15 .bottom-part"),
      // endTrigger:$.CN('.section-16'),
      start: function start() {
        return "top bottom-=30%";
      },
      end: function end() {
        return "top+=".concat($($.CN(".section-15 .bottom-part-inside")).height(), " bottom-=10%");
      },
      // pin:true,
      // pinType:"transform",
      // pinSpacing: false,
      // anticipatePin: 1,
      once: true,
      invalidateOnRefresh: true,
      markers: markers,
      scrub: 0.5,
      id: "s15"
    });
    ScrollTrigger.create({
      trigger: $.CN(".section-15 .bottom-part"),
      start: function start() {
        return "top bottom-=30%";
      },
      // endTrigger:$.CN('.section-16'),
      end: function end() {
        return "top+=".concat($($.CN(".section-15 .bottom-part-inside")).height(), " bottom-=15%");
      },
      pin: $.CN(".section-15 .video-holder.hide-mobile"),
      pinType: "transform",
      pinSpacing: false,
      once: true,
      // anticipatePin: 1,
      invalidateOnRefresh: true,
      markers: markers,
      scrub: true,
      id: "s15-2"
    });
  }

  // ScrollTrigger.create({
  // trigger:$.CN('.section-15 .bottom-part-inside'),

  // start:"top bottom-=50%",
  // end:"bottom bottom",
  // pin:$.CN('.section-15 .video-holder'),
  // // pinSpaceing:false,
  //   markers:true,
  // scrub: 1,
  // id:'s15-2',
  // })

  // if(isPhone){
  // let quence15Mob = new Sequence({
  //   canvas: document.getElementById("s15canvas-mobile"),
  //   imgLenth: 41,
  //   timeSpan: 70,
  //   // imgUrl: `https://cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/robo_q7_sixth_map`,
  //   // imgUrl: `${BASE_URL}files/${PREFIXER}s1ban_`, //或者
  //   imgUrl:`${BASE_URL}files/${PREFIXER}section-15_dock_`,
  //   imgtype:'.jpg',
  //   fillZeroLength:5,
  //   pictureCoefficient: 2,
  //   isFullscreen: false
  // });

  // let tl=gsap.timeline();
  // tl.add([

  //     gsap.fromTo($.CN(".section-15 .bottom-part"),{duration:4},{

  //         onUpdate:function(){
  //           quence15Mob.gotoAndStop(41*this.progress())
  //     }

  //     }),

  //     ])

  // ScrollTrigger.create({
  //   animation:tl,
  //     trigger:$.CN('.section-15 .bottom-part .video-holder'),
  //     // endTrigger:$.CN('.section-16'),
  //   start:function(){return 'top bottom-=40%'},
  //   end:function(){return `bottom bottom-=40%`},
  //   // pin:true,
  //   // pinType:"transform",
  //   // pinSpacing: false,
  //   // anticipatePin: 1,
  //   once:true,
  //   invalidateOnRefresh:true,
  //   markers,
  //   scrub: 0.5,
  //   id:'s15',
  //   })

  // }
});

/***/ }),

/***/ "./src/sections/section16-expand/index.js":
/*!************************************************!*\
  !*** ./src/sections/section16-expand/index.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section16-expand/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  window.ttt1 = function (v) {
    afterPopupShown();
    show4Expand(v);
    $($.CN(".section-16-expand")).addClass("".concat("Qrevo_Edge_Series_", "active"));
  };
  window.ttt2 = function () {
    afterPopupHidden();
    $($.CN(".section-16-expand")).removeClass("".concat("Qrevo_Edge_Series_", "active"));
  };
  $($.CN(".section-4 .link")).click(function () {
    afterPopupShown();
    show4Expand();
    $($.CN(".section-16-expand")).addClass("".concat("Qrevo_Edge_Series_", "active"));
  });
  $($.CN(".section-16-expand .closeBtn")).click(function () {
    afterPopupHidden();
    $($.CN(".section-16-expand")).removeClass("".concat("Qrevo_Edge_Series_", "active"));
  });
  $($.CN(".section-16-expand .link-card")).click(function () {
    // $($.CN(".section-16-expand .popup")).addClass(`${PREFIXER}active`);
    // $($.CN(".section-16-expand .popup .popup-content-wrapper")).get(0).scrollTop = 0;

    $(this).css({
      pointerEvents: "none"
    });
    gsap.to($.CN(".section-16-expand .link-card"), 0.3, {
      opacity: 0
    });
    $($.CN(".section-16-expand .popup")).css({
      marginTop: $(this).outerHeight() * -1
    });
    gsap.to($.CN(".section-16-expand .popup"), 1, {
      opacity: 1,
      height: $($.CN(".section-16-expand .popup .popup-panel")).outerHeight()
    });
  });

  //   $($.CN(".section-16-expand .popup .popCloseBtn")).click(function () {
  //     $($.CN(".section-16-expand .popup")).removeClass(`${PREFIXER}active`);
  //   });

  function show4Expand() {
    var morePopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    afterPopupShown();
    $($.CN(".section-16-expand")).addClass("".concat("Qrevo_Edge_Series_", "active ").concat(morePopup ? "Qrevo_Edge_Series_" + "morePopup" : ""));
    $($.CN(".section-16-expand .scroll-wrapper")).get(0).scrollTop = 0;
    if (morePopup) {
      //   let linkHeight=$($.CN(".section-16-expand .link")).outerHeight();
      //   $($.CN(".section-16-expand .link")).css({borderRadius:linkHeight/2,paddingRight:linkHeight+10})
      //   $($.CN(".section-16-expand .link-holder svg")).css({
      //     width: linkHeight+"px",
      //     height: linkHeight+"px",
      //   })
      // let w=$($.CN(".section-16-expand .link-holder .link")).outerWidth()
      //   $($.CN(".section-16-expand .link-holder")).addClass(`${PREFIXER}active`);
      //   gsap.fromTo($.CN(".section-16-expand .svg-holder svg"), 1.3,{right:w}, {ease: "none",right:linkHeight});
      //   gsap.to($.CN(".section-16-expand .link-holder .link"), 1.5, {
      //     // ease: customEase,
      //     ease: "none",
      //     onUpdate: function (t) {
      //       let w=$($.CN(".section-16-expand .link-holder .link")).outerWidth()
      //       let w2=$($.CN(".section-16-expand .svg-holder svg")).width()
      //       let p1=(w-w2)*this.progress();
      //       let p2=p1+w2;
      //       $($.CN(".section-16-expand .link-holder .link")).css({
      //         "-webkit-mask-image": "linear-gradient(90deg, black " + p1 + "px,  transparent " + p2 +  "px)",
      //         "mask-image": "linear-gradient(90deg, black " + p1 + "px,  transparent " + p2 + "px)",
      //         // backgroundImage: `linear-gradient(to left, #fff ${w*(1-this.progress())}px, transparent ${w*(1-this.progress())+w2}px)`
      //      })
      //     }
      //   })
    }
  }

  //test
  // setTimeout(()=>{
  //     show4Expand(true)
  // },500)

  window.show4Expand = show4Expand;
});

/***/ }),

/***/ "./src/sections/section16/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section16/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section16/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  // ScrollTrigger.create({
  //     trigger:$.CN('.section-16 .video-holder'),
  //     start:'bottom 50%',
  //     end:`bottom 25%`,
  //     onUpdate:function(self){
  //       $($.CN('.section-16 .video-holder')).css({"--inset": (self.progress*10)+'%',
  //         '--round': (self.progress*10)+'px'})
  //     },
  //     markers,
  //     scrub: 0.2,
  //     id:'s16-video'
  //   })

  $($.CN(".section-16 .link-holder")).click(function () {
    show4Expand(true);
    // $($.CN(".section-16-expand")).addClass(`${PREFIXER}active`);
  });

  // $($.CN(".section-16-expand .closeBtn")).click(function () {
  //   afterPopupHidden();
  //   $($.CN(".section-16-expand")).removeClass(`${PREFIXER}active`);
  // })

  //   ScrollTrigger.create({
  //     // animation:gsap.timeline().fromTo($.CN(".section-twelfth .svg-holder::after"), 0.5, { backgroundImage: "linear-gradient(to left, #000 0%, transparent 100%)"}, { backgroundImage: "linear-gradient(to left, #000 0%, transparent 100%)"}),
  //     trigger: $.CN(".section-16 .card-part .link-holder"),
  //     start: "top bottom-=10%",
  //     end: "top bottom-=10%",

  //     onEnter: () => {
  //         let w=$($.CN(".section-16 .link-holder .link")).outerWidth()
  //         let linkHeight=$($.CN(".section-16 .link")).outerHeight();
  //       $($.CN(".section-16 .link-holder")).addClass(`${PREFIXER}active`);
  //       gsap.fromTo($.CN(".section-16 .svg-holder svg"), 1.3,{right:w}, {ease: "none",right:linkHeight});
  //       gsap.to($.CN(".section-16 .link-holder .link"), 1.5, {
  //         // ease: customEase,
  //         ease: "none",
  //         onUpdate: function (t) {
  //           let w=$($.CN(".section-16 .link-holder .link")).outerWidth()
  //           let w2=$($.CN(".section-16 .svg-holder svg")).width()

  //           let p1=(w-w2)*this.progress();
  //           let p2=p1+w2;

  //           $($.CN(".section-16 .link-holder .link")).css({

  //             "-webkit-mask-image": "linear-gradient(90deg, black " + p1 + "px,  transparent " + p2 +  "px)",
  //             "mask-image": "linear-gradient(90deg, black " + p1 + "px,  transparent " + p2 + "px)",

  //             // backgroundImage: `linear-gradient(to left, #fff ${w*(1-this.progress())}px, transparent ${w*(1-this.progress())+w2}px)`
  //          })
  //         }
  //       })
  //     },
  //     //反向离开
  //     onLeaveBack: () => {
  //         let w=$($.CN(".section-16 .link-holder .link")).outerWidth()
  //         let w2=$($.CN(".section-16 .svg-holder svg")).width()
  //       $($.CN(".section-16 .link-holder")).removeClass(`${PREFIXER}active`)
  //       $($.CN(".section-16 .svg-holder svg")).css({right:w})
  //     //   gsap.to($.CN(".section-16 .svg-holder svg"), 1.5, {right:w-w2});
  //     //   gsap.to($.CN(".section-16 .svg-holder .bg-mask"), 0.3, {
  //     //     onUpdate: function (t) {
  //     //       $($.CN(".section-16 .svg-holder .bg-mask")).css({ backgroundImage: `linear-gradient(to left, #000 ${100 - (1 - this.progress()) * 100}%, transparent ${115 - (1 - this.progress()) * 100}%)` })
  //     //     }
  //     //   })
  //     },
  //     // once:true,
  //     scrub: 0.3,
  //     markers,
  //     invalidateOnRefresh: true,
  //     id: "s16"
  //   })

  window.scroll16 = null;
  window.addEventListener("languagechange", function () {
    var linkHeight = $($.CN(".section-16 .link-holder")).outerHeight();
    // $($.CN(".section-16 .link-holder")).css({ paddingRight: window.bodyFontSize * 0.4 + "px" });
    $($.CN(".section-16 .link-holder .svg-holder")).css({
      width: linkHeight - window.bodyFontSize * 0.4 + "px",
      height: linkHeight - window.bodyFontSize * 0.4 + "px",
      right: window.bodyFontSize * 0.2 + "px"
    });
  });
});

/***/ }),

/***/ "./src/sections/section17/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section17/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section17/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section18/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section18/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section18/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section19/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section19/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section19/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section2/index.js":
/*!****************************************!*\
  !*** ./src/sections/section2/index.js ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section2/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");
/**
 * 第二部分
 */

$(function () {
  __webpack_require__(/*! @/widgets/FullScreenVideo */ "./src/widgets/FullScreenVideo/index.js");
});

/***/ }),

/***/ "./src/sections/section20/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section20/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section20/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  var swiperElement = document.querySelector($.CN(".section-20 .swiper"));
  var swiperWrapper = swiperElement.querySelector($.CN(".section-20 .swiper-wrapper"));
  var swiperSlides = swiperElement.querySelectorAll($.CN(".section-20 .swiper-slide"));
  swiperSlides.forEach(function (slide, _) {
    var clonedSlide = slide.cloneNode(true);
    swiperWrapper.appendChild(clonedSlide);
  });
  $($.CN(".section-20 .swiper-pagination-bullet")).click(function () {
    var index = $(this).index();
    swiper20.slideTo(index);
  });
  function handleResize(swiper) {
    //设定一下.top-part的宽度和一个slide的宽度一样
    var slideWidth = swiper.slides[0].offsetWidth;

    //  $($.CN(".section-20 .nav-part .swiper-pagination")).css({width:slideWidth});
    // $($.CN(".section-29  .top-part")).removeClass(`${PREFIXER}active`);

    $($.CN(".section-20  .nav-part")).css({
      width: slideWidth * (isPhone ? 1 : 2)
    });
    $($.CN(".section-20  .nav-part .swiper-pagination")).css({
      width: slideWidth
    });
    $($.CN(".section-20  .bottom-text-part")).css({
      width: slideWidth
    });
    // $($.CN(".section-29  .top-part")).removeClass(`${PREFIXER}active`);

    var maxTitleHeight20 = 0;
    $($.CN(".section-20 .nav-part .title")).each(function () {
      maxTitleHeight20 = Math.max(maxTitleHeight20, $(this).height());
    });
    $($.CN(".section-20 .title-part")).css({
      minHeight: maxTitleHeight20
    });
    var maxTextHeight20 = 0;
    $($.CN(".section-20 .bottom-text-part .text")).each(function () {
      maxTextHeight20 = Math.max(maxTextHeight20, $(this).height());
    });
    $($.CN(".section-20 .bottom-text-part")).css({
      minHeight: maxTextHeight20
    });
    var maxHeight = 0;
    $($.CN(".section-20 .swiper-slide")).each(function () {
      maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });
    $($.CN(".section-20 .swiper-slide")).css({
      height: maxHeight
    });
  }
  var swiper20 = window.abc = new Swiper($.CN(".section-20 .swiper"), {
    slidesPerView: "auto",
    // spaceBetween: 10,
    freeMode: true,
    // autoplay: {
    //     delay: 0,
    //     pauseOnMouseEnter: false,        // added
    //     disableOnInteraction: false,    // added
    // },
    autoHeight: true,
    slidesOffsetBefore: isPhone ? window.contentPadding3 : 0,
    // slideToClickedSlide: true,
    centeredSlides: false,
    loop: true,
    // speed: 5000,
    // pagination: {
    //   clickable :true,
    //   el: $.CN(".section-20 .swiper-pagination"),
    // },
    navigation: {
      nextEl: $.CN(".section-20  .swiper-button-next"),
      prevEl: $.CN(".section-20  .swiper-button-prev")
    },
    on: {
      init: function init(swiper) {
        //   //设定一下.top-part的宽度和一个slide的宽度一样
        //   let slideWidth = swiper.slides[0].offsetWidth - bodyFontSize*0.3;
        //   $($.CN(".section-20  .top-part")).css({width:slideWidth});
        //   // $($.CN(".section-29  .top-part")).removeClass(`${PREFIXER}active`);
        var slideWidth = swiper.slides[0].offsetWidth;
        $($.CN(".section-20 .nav-part .swiper-pagination")).css({
          width: slideWidth
        });

        //让所有的slide等于最高的一个slide
        var maxHeight = 0;
        $($.CN(".section-20 .swiper-slide")).each(function () {
          maxHeight = Math.max(maxHeight, $(this).outerHeight());
        });
        $($.CN(".section-20 .swiper-slide")).css({
          height: maxHeight
        });
      },
      resize: handleResize,
      click: function click() {
        var index = this.clickedIndex % $($.CN(".section-20 .swiper-pagination-bullet")).length;
        // console.log("click了，activeIndex为" + this.activeIndex, this.realIndex,index);
        // this.slideTo(this.clickedIndex)
        this.slideTo(index, 0);
      },
      slideChange: function slideChange() {
        var index = this.realIndex % $($.CN(".section-20 .swiper-pagination-bullet")).length;
        // console.log("改变了，activeIndex为" + this.activeIndex, this.realIndex, index);

        $($.CN(".section-20  .title-part .title")).removeClass("".concat("Qrevo_Edge_Series_", "active"));
        $($.CN(".section-20  .title-part .title")).eq(index).addClass("".concat("Qrevo_Edge_Series_", "active"));
        $($.CN(".section-20  .bottom-text-part .text")).removeClass("".concat("Qrevo_Edge_Series_", "active"));
        $($.CN(".section-20  .bottom-text-part .text")).eq(index).addClass("".concat("Qrevo_Edge_Series_", "active"));
        $($.CN(".section-20 .swiper-pagination-bullet")).removeClass("swiper-pagination-bullet-active");
        $($.CN(".section-20 .swiper-pagination-bullet")).get(index).classList.add("swiper-pagination-bullet-active");

        //   // alert('改变了，activeIndex为'+this.activeIndex);

        //   let index=this.activeIndex;

        //   $($.CN(".section-20 video")).each(function(index){
        //     if(index!=this.activeIndex)
        //       $(this).get(0)?.pause();
        //   })
        //   $($.CN(".section-20 video")).get(index).removeEventListener('ended',handlePlayEnd20)
        //   $($.CN(".section-20 video")).get(index).addEventListener('ended',handlePlayEnd20)
        //   $($.CN(".section-20 video")).get(index).currentTime = 0;
        //     $($.CN(".section-20 video")).get(index).play().catch(function(error) {
        //       if (error.name === 'AbortError') {
        //         // Ignore `AbortError`. This error name is "AbortError" in Chrome, and "NotAllowedError" in Firefox.
        //         return;
        //       }
        //       console.error(error);
        //     });
      }
    }
  });

  // function handlePlayEnd20()
  // {
  //   // console.log('Video has ended!');
  //   this.currentTime = 0;
  //   this.removeEventListener('ended',handlePlayEnd20,false);
  //   swiper20.slideNext();
  // }
  handleResize(swiper20);
  window.addEventListener("resize", function () {
    swiper20.params.slidesOffsetBefore = window.contentPadding3; // 你的计算函数
    swiper20.update();
  });
});

/***/ }),

/***/ "./src/sections/section21/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section21/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section21/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  // var swiper21 = (window.sss = new Swiper($.CN(".section-21 .swiper"), {
  //   slidesPerView: "auto",
  //   spaceBetween: 0,
  //   // freeMode: true,
  //   slidesOffsetBefore: isPhone ? window.contentPadding3 : window.contentPadding2,
  //   autoplay: {
  //     paused: true,
  //     delay: 2000,
  //     pauseOnMouseEnter: false, // added
  //     disableOnInteraction: false, // added
  //   },
  //   initialSlide: 0,
  //   loop: true,
  //   speed: 2000,
  // }));
  // swiper21.autoplay.stop();
  // ScrollTrigger.create({
  //   trigger: $.CN(".section-21 .swiper"),
  //   start: "top bottom-=10%",
  //   end: "top bottom-=10%",
  //   markers,
  //   onEnter: () => {
  //     swiper21.autoplay.start();
  //   },
  //   onLeaveBack: () => {
  //     swiper21.slideTo(0, 0);
  //     swiper21.autoplay.stop();
  //   },
  // });
});

/***/ }),

/***/ "./src/sections/section23/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section23/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section23/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  // $(`${$.CN(".section-23  .switcher")}`).click(() => {
  //     $(`${$.CN(".section-23  .content-wrapper")}`).toggleClass(`${PREFIXER}day`)
  //     // let startPos=st23.start;
  //     // let midPos=(st23.start+st23.end)/2+1;
  //     // if(st23.progress<0.5)
  //     //   st23.scroll(midPos)
  //     // else
  //     //   st23.scroll(startPos)
  //   })
  $($.CN(".section-23 .btn-block")).on("click", function (e) {
    e.stopPropagation();
    $("".concat($.CN(".section-23  .content-wrapper"))).toggleClass("".concat("Qrevo_Edge_Series_", "day"));
  });
  ScrollTrigger.create({
    trigger: $.CN(".section-23"),
    start: "top top",
    onEnter: function onEnter() {
      ScrollTrigger.create({
        trigger: $.CN(".section-23"),
        start: "center bottom-=80%",
        end: "center bottom-=50%",
        onEnter: function onEnter(self) {
          $("".concat($.CN(".section-23  .content-wrapper"))).removeClass("".concat("Qrevo_Edge_Series_", "day"));
        },
        onEnterBack: function onEnterBack(self) {
          $("".concat($.CN(".section-23  .content-wrapper"))).addClass("".concat("Qrevo_Edge_Series_", "day"));
        },
        scrub: true,
        invalidateOnRefresh: true
      });
    },
    once: true,
    scrub: true,
    invalidateOnRefresh: true
  });
  //   $($.CN(".section-23 .pin-spacer")).css("height",`${Math.max($(`${$.CN(".section-23  .content-wrapper")}`).outerHeight()/2,window.innerHeight/2)}px`)

  //  var st23=window.sts=ScrollTrigger.create({
  //     // animation:gsap.timeline().fromTo($.CN(".section-twelfth .svg-holder::after"), 0.5, { backgroundImage: "linear-gradient(to left, #000 0%, transparent 100%)"}, { backgroundImage: "linear-gradient(to left, #000 0%, transparent 100%)"}),
  //     trigger: $.CN(".section-23 .pin-spacer"),
  //     start: "top bottom",
  //     end: function(){return "top bottom-="+Math.max($(`${$.CN(".section-23  .content-wrapper")}`).outerHeight()/2,window.innerHeight/2)},

  //     onUpdate: (self) => {
  //       if(self.progress>0.5)
  //         $(`${$.CN(".section-23  .content-wrapper")}`).removeClass(`${PREFIXER}day`)
  //       else
  //         $(`${$.CN(".section-23  .content-wrapper")}`).addClass(`${PREFIXER}day`)
  //     },

  //     // onEnter: () => {
  //     //   console.log("enter23")
  //     //   $(`${$.CN(".section-23  .content-wrapper")}`).addClass(`${PREFIXER}day`)
  //     // },
  //     // //反向离开
  //     // onEnterBack: () => {
  //     //   console.log("enter back23")
  //     //   $(`${$.CN(".section-23  .content-wrapper")}`).removeClass(`${PREFIXER}day`)
  //     // },
  //     // once:true,
  //     pin:$.CN(".section-23 .content-wrapper"),
  //     pinSpacing: false,
  //     pinType: "transform",
  //     // pinSpacer:$.CN(".section-23 .pin-spacer"),
  //     scrub: 0,
  //     markers,
  //     invalidateOnRefresh: true,
  //     id: "s23"
  //   })
});

/***/ }),

/***/ "./src/sections/section24/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section24/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section24/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section25/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section25/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section25/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  if (!isPhone) {
    ScrollTrigger.create({
      trigger: $.CN(".section-25"),
      pin: $.CN(".section-25 .left-part-content"),
      start: "top top",
      end: "bottom bottom",
      scrub: 1,
      markers: markers,
      pinSpacing: false,
      id: "s25"
    });
    ScrollTrigger.create({
      onEnter: function onEnter() {
        $($.CN(".section-25 .title-part")).addClass("".concat("Qrevo_Edge_Series_", "active"));
      },
      onLeaveBack: function onLeaveBack() {
        $($.CN(".section-25 .title-part")).removeClass("".concat("Qrevo_Edge_Series_", "active"));
      },
      trigger: $.CN(".section-25 .content-container"),
      start: "top bottom-=50%",
      end: "top bottom-=50%",
      markers: markers,
      invalidateOnRefresh: true,
      scrub: 0.5,
      id: "s31"
    });
  } else {
    $($.CN(".section-25 .title-part")).addClass("".concat("Qrevo_Edge_Series_", "active"));
  }
});

/***/ }),

/***/ "./src/sections/section26/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section26/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section26/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  function clickItem(index) {
    $($.CN(".section-26 .bottom-part2 .text-item")).eq(index).addClass("".concat("Qrevo_Edge_Series_", "active")).siblings().removeClass("".concat("Qrevo_Edge_Series_", "active"));
    var h = $($.CN(".section-26 .bottom-part2 .text-item:nth-child(" + (index + 1) + ") .text")).outerHeight();
    var pt = $($.CN(".section-26 .bottom-part2 .text-item:nth-child(" + (index + 1) + ") .text")).css("paddingTop").replace("px", "");
    if (h <= Number(pt)) h = "auto";
    $($.CN(".section-26 .bottom-part2 .text-item:nth-child(" + (index + 1) + ") .text-wrap")).css({
      height: h
    });
    $($.CN(".section-26 .bottom-part2 .text-item:nth-child(" + (2 - index) + ") .text-wrap")).css({
      height: 0
    });
    $($.CN(".section-26 .bottom-part2 .pic-item:nth-child(" + (index + 1) + ")")).addClass("".concat("Qrevo_Edge_Series_", "active")).siblings().removeClass("".concat("Qrevo_Edge_Series_", "active"));
    if (index == 0) {
      $($.CN(".section-26 .bottom-part2 .navbar")).removeClass("".concat("Qrevo_Edge_Series_", "active"));
    } else {
      $($.CN(".section-26 .bottom-part2 .navbar")).addClass("".concat("Qrevo_Edge_Series_", "active"));
    }
  }
  $($.CN(".section-26 .bottom-part2 .text-item")).click(function () {
    var index = $(this).index();
    clickItem(index);
  });
  clickItem(0);
  setTimeout(function () {
    ScrollTrigger.create({
      tags: [0, 0.5, 1],
      trigger: $.CN(".section-26 .bottom-part2"),
      start: "top bottom-=50%",
      end: "bottom bottom-=50%",
      markers: markers,
      onTag: function onTag(t) {
        if (t.tag == 0.5) {
          if (t.direction == "forward") clickItem(1);else clickItem(0);
        }
      }
    });
  }, 1000);
});

/***/ }),

/***/ "./src/sections/section27/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section27/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section27/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section28/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section28/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section28/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section29/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section29/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section29/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section3/index.js":
/*!****************************************!*\
  !*** ./src/sections/section3/index.js ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section3/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  var anim = gsap.fromTo($.CN(".section-3 .content-wrapper"), 1, {}, {
    paused: true,
    onUpdate: function onUpdate() {
      if (!this.isActive()) return;
      var p = this.progress();
      $($.CN(".section-3 .text.mask")).css({
        "-webkit-mask-image": "linear-gradient(135deg, black " + p * 100 + "%,  transparent " + (50 + p * 100) + "%)"
        //         "mask-image": "radial-gradient(circle, black " + (self.progress * 100) + "%,  transparent " + (50 + self.progress * 100) + "%)",
        // "-webkit-mask-image": "linear-gradient(135deg, black " + (p * 150 - 50) + "%,  transparent " + ( p * 150) + "%)",
        // "mask-image": "linear-gradient(135deg, black " + (p * 150 - 50) + "%,  transparent " + ( p * 150) + "%)",
      });
    }
  });
  ScrollTrigger.create({
    trigger: $.CN(".section-3 .content-wrapper"),
    start: isPhone ? "top bottom-=50%" : "top bottom-=30%",
    // endTrigger: $.CN(".section-second .playvideo-wrapper"),
    end: "top bottom-=10%",
    onEnter: function onEnter() {
      // console.log('onEnter');
      anim.play();
    },
    onLeaveBack: function onLeaveBack() {
      // console.log('onLeaveBack');
      anim.reverse();
    },
    // onUpdate: (self) => {
    //   $($.CN(".section-3 .text.mask")).css({
    //     "-webkit-mask-image": "linear-gradient(135deg, black " + (self.progress * 150 - 50) + "%,  transparent " + (self.progress * 150) + "%)",
    //     "mask-image": "linear-gradient(135deg, black " + (self.progress * 150 - 50) + "%,  transparent " + ( self.progress * 150) + "%)",
    //   })
    // },
    scrub: true,
    markers: markers,
    invalidateOnRefresh: true,
    id: "s3"
  });
  if (isPhone) {
    //hackfix: 强制再刷新一下ScrollTrigger
    setTimeout(function () {
      ScrollTrigger.refresh();
    }, 100);
  }
});

/***/ }),

/***/ "./src/sections/section35/index.js":
/*!*****************************************!*\
  !*** ./src/sections/section35/index.js ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section35/index.less");
/* harmony import */ var _widgets_Album__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/widgets/Album */ "./src/widgets/Album/index.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");


$(function () {});

/***/ }),

/***/ "./src/sections/section5/index.js":
/*!****************************************!*\
  !*** ./src/sections/section5/index.js ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section5/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  if (!isPhone) {
    $($.CN(".section-5 .cards-holder>a.hoverable")).each(function () {
      var self = this;
      $(this).hover(function () {
        $(self).addClass("".concat("Qrevo_Edge_Series_", "hover"));
        gsap.fromTo($(self).find($.CN(".ul-holder")).get(0), 0.3, {
          height: 0,
          opacity: 0
        }, {
          ease: "sine.inOut",
          height: $(self).find($.CN(".ul-holder ul")).get(0).clientHeight,
          opacity: 1
        });
        gsap.to($(self).find($.CN("img")).get(0), 0.3, {
          ease: "sine.inOut"
          // scale: 1.05,
        });
      }, function () {
        $(self).removeClass("".concat("Qrevo_Edge_Series_", "hover"));
        gsap.to($(self).find($.CN(".ul-holder")).get(0), 0.3, {
          ease: "sine.inOut",
          height: 0,
          opacity: 0
        });
        gsap.to($(self).find($.CN("img")).get(0), 0.3, {
          ease: "sine.inOut",
          scale: 1
        });
      });
    });
  }
});

/***/ }),

/***/ "./src/sections/section7/index.js":
/*!****************************************!*\
  !*** ./src/sections/section7/index.js ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section7/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {});

/***/ }),

/***/ "./src/sections/section8/index.js":
/*!****************************************!*\
  !*** ./src/sections/section8/index.js ***!
  \****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/sections/section8/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");

$(function () {
  //计算拼接布局
  window.onresize = function () {
    if (isPhone) {
      //整个卡片的内部宽度
      var W = $($.CN(".section-8 .card-part:nth-of-type(1) .img-card")).width();

      //左边两个卡片的宽高比
      var r1 = 300 / 99;
      //右边卡片的宽高比
      var r2 = 197 / 99;

      //卡片间的间距
      var C = 5;

      //计算左边卡片在宽上的占比，用于设定左右两边的flex的值

      var leftFlex = (W / r2 - C) / (2 * W / r1 + W / r2);
      var rightFlex = 1 - leftFlex;
      $($.CN(".section-8 .card-part:nth-of-type(1) .img-card .left-img-cards")).css({
        flexGrow: leftFlex,
        flexShrink: 1,
        flexBasis: "0%"
      });
      $($.CN(".section-8 .card-part:nth-of-type(1) .img-card .right-img-cards")).css({
        flexGrow: rightFlex,
        flexShrink: 1,
        flexBasis: "0%"
      });
    }
  };
  window.onresize();
});

/***/ }),

/***/ "./src/widgets/Album/index.js":
/*!************************************!*\
  !*** ./src/widgets/Album/index.js ***!
  \************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/widgets/Album/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// 相册组件
/**
 * 同时包括点击放大查看功能
 * 需引入
 * <link rel="stylesheet" href="//cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/swiper8-bundle.min.css">
   <script defer="defer" src="//cdn.shopify.com/s/files/1/0082/3666/2902/t/65/assets/swiper8-bundle.min.js"></script>

 * 结构组件
 * <section data-section="35" class="section section-35 section-album">
      <div class="content-wrapper flex fd-c ai-start  ">
        <div class="fade-out top-title flex  ai-center active  ">
          <span class="title font-7">{{'model.section-35.title' | t}}</span>
        </div>
        <div class="fade-out cards-part flex fd-c">
          <div class="swiper swiper1">
            <div class="swiper-wrapper">
              <!-- 1 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album1.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 2 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album2.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 3 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album3.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 4 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album4.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 5 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album5.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 6 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album6.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 7 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album7.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 8 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album8.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 9 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album9.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 10 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album10.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- end -->
            </div>
          </div>
          <div class="swiper swiper2">
            <div class="swiper-wrapper">
              <!-- 1 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album1.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 2 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album2.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 3 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album3.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 4 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album4.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 5 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album5.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 6 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album6.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 7 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album7.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 8 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album8.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 9 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album9.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 10 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy" alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album10.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- end -->
            </div>
          </div>
        </div>
      </div>

      <div class="gallery_popup popup">
        <div class="popup-content-wrapper">
          <div class="popup-panel">


            <div class="content-wrapper flex fd-c">
          <div class="swiper gallery">
            <div class="swiper-wrapper">
              <!-- 1 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album1.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 2 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album2.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 3 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album3.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 4 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album4.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 5 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album5.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 6 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album6.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 7 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album7.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 8 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album8.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 9 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album9.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 10 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album10.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- end -->
            </div>
          </div>
          <div class="gallery_thumbs_holder flex  ai-center">
            <div class="swiper-button">
            <div class="swiper-button-prev"> <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 1L1 6L6 11" stroke="#FFE9E9" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg></div>
            </div>
          <div class="swiper gallery_thumbs">
            <div class="swiper-wrapper">
              <!-- 1 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album1.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 2 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album2.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 3 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album3.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 4 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album4.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 5 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album5.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 6 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album6.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 7 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album7.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 8 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album8.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 9 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album9.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- 10 -->
              <div class=" swiper-slide card flex fd-c">
                <span class="img-holder">
                  <img loading="lazy"  alt="This is a image" class="pic1 w-100"
                    src="{{ 'section-35/Album10.jpg' | file_img_url: 'master' }}" />
                </span>
              </div>
              <!-- end -->
            </div>
          </div>
          <div class="swiper-button">
          <div class="swiper-button-next">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6 6L1 11" stroke="#FFE9E9" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
        </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <svg class="popCloseBtn btn" width="32" height="32" viewBox="0 0 32 32" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="15.5" transform="rotate(90 16 16)" stroke="#B0B0B0" />
          <path d="M21.5254 10.4727L9.77837 22.2212" stroke="#737373" stroke-width="2" />
          <path d="M21.5254 22.2227L17.1197 17.817M9.77685 10.4756L15.6504 16.3484" stroke="#737373"
            stroke-width="2" />
        </svg>


    </section>

 */

/* 使用
import "@/widgets/Album";
*/


/* harmony default export */ __webpack_exports__["default"] = ((function () {
  function Album() {
    new Swiper($.CN('.section-album .swiper.swiper1'), _defineProperty(_defineProperty(_defineProperty(_defineProperty({
      slidesPerView: "auto",
      spaceBetween: 6,
      slidesOffsetBefore: 50,
      freeMode: true,
      initialSlide: 3,
      autoplay: {
        delay: 1,
        stopOnLastSlide: false,
        pauseOnMouseEnter: false,
        // added
        disableOnInteraction: false // added
      }
    }, "slidesOffsetBefore", bodyFontSize * 3.46 / 2), "loop", true), "speed", 5000), "on", {
      click: function click(swiper) {
        show35photo($(swiper.clickedSlide).data("swiper-slide-index"));
        // console.log('你点了Swiper', $(swiper.clickedSlide).data("swiper-slide-index"));
      }
    }));
    new Swiper($.CN('.section-album .swiper.swiper2'), {
      slidesPerView: "auto",
      spaceBetween: 6,
      slidesOffsetBefore: 50,
      freeMode: true,
      initialSlide: 7,
      autoplay: {
        delay: 1,
        stopOnLastSlide: false,
        pauseOnMouseEnter: false,
        // added
        disableOnInteraction: false // added
      },
      loop: true,
      speed: 5000,
      on: {
        click: function click(swiper) {
          show35photo($(swiper.clickedSlide).data("swiper-slide-index") + 5);
          // console.log('你点了Swiper', $(swiper.clickedSlide).data("swiper-slide-index"));
        }
      }
    });
    var thumbsSwiper = new Swiper($.CN(".section-album .gallery_thumbs"), {
      spaceBetween: isPhone ? 5 : 10,
      autoHeight: true,
      slidesPerView: isPhone ? 3 : 5,
      watchSlidesVisibility: true //防止不可点击
    });
    var gallerySwiper = new Swiper($.CN(".section-album .gallery"), {
      spaceBetween: 10,
      slidesPerView: 1,
      autoHeight: true,
      thumbs: {
        swiper: thumbsSwiper
      },
      navigation: {
        nextEl: $.CN(".section-album .gallery_thumbs_holder .swiper-button-next"),
        prevEl: $.CN(".section-album .gallery_thumbs_holder .swiper-button-prev")
      }
    });
    function show35photo(index) {
      afterPopupShown();
      thumbsSwiper.slideTo(index, 10, false);
      gallerySwiper.slideTo(index, 10, false);
      $($.CN(".section-album .popup")).addClass("".concat("Qrevo_Edge_Series_", "active"));
    }
    $($.CN(".section-album .popup .popCloseBtn")).click(function () {
      afterPopupHidden();
      $($.CN(".section-album .popup")).removeClass("".concat("Qrevo_Edge_Series_", "active"));
    });
  }
  $(Album);
})());

/***/ }),

/***/ "./src/widgets/ComparisonContainer/data.js":
/*!*************************************************!*\
  !*** ./src/widgets/ComparisonContainer/data.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// 对比模块的6个icon
/* harmony default export */ __webpack_exports__["default"] = ({
  "item1": ["<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M25 47C37.1462 47 47 37.1462 47 25C47 12.8538 37.1462 3 25 3C12.8538 3 3 12.8449 3 25C3 37.1551 12.8538 47 25 47Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M35.3692 13.458C35.3692 13.458 32.4815 14 30.3224 16.6123C28.3409 19.0469 28.4298 21.2149 28.4298 21.2149\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M24.547 9.49512C24.547 9.49512 22.8321 11.8408 23.1076 15.2617C23.3741 18.416 24.9113 19.9531 24.9113 19.9531\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M13.5469 14.5422C13.5469 14.5422 14.0889 17.43 16.7012 19.5891C19.1357 21.6594 21.3037 21.4817 21.3037 21.4817\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M9.49512 25.178C9.49512 25.178 11.8408 26.8928 15.2617 26.7151C18.416 26.5374 19.9531 25.0002 19.9531 25.0002\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M14.6309 36.3645C14.6309 36.3645 17.5186 35.8225 19.6777 33.2102C21.6591 30.7757 21.5703 28.6077 21.5703 28.6077\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25.4532 40.4162C25.4532 40.4162 27.168 38.0705 26.8926 34.6497C26.626 31.4954 25.0889 29.9583 25.0889 29.9583\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M36.4532 35.3693C36.4532 35.3693 35.9112 32.4815 33.2989 30.3224C30.8643 28.2521 28.6963 28.4298 28.6963 28.4298\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M40.416 24.7337C40.416 24.7337 38.0703 23.0188 34.6494 23.1965C31.4952 23.3742 29.958 24.9114 29.958 24.9114\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25 30.0468C27.79 30.0468 30.0468 27.79 30.0468 25C30.0468 22.21 27.79 19.9531 25 19.9531C22.21 19.9531 19.9531 22.21 19.9531 25C19.9531 27.79 22.21 30.0468 25 30.0468Z\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25 40.5048C33.5654 40.5048 40.5048 33.5654 40.5048 25C40.5048 16.4345 33.5654 9.49512 25 9.49512C16.4345 9.49512 9.49512 16.4345 9.49512 25C9.49512 33.5654 16.4345 40.5048 25 40.5048Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M20.5656 19.8188H8.85204C7.66361 19.8188 6.7002 20.7823 6.7002 21.9707V25.1219C6.7002 26.3103 7.66361 27.2738 8.85204 27.2738H20.5656C21.754 27.2738 22.7175 26.3103 22.7175 25.1219V21.9707C22.7175 20.7823 21.754 19.8188 20.5656 19.8188Z\" stroke=\"#DB2D30\" stroke-width=\"1.57\" stroke-miterlimit=\"10\"/>\n      <path d=\"M15.4156 19.6841C15.4156 19.6841 11.0489 23.1144 6.7002 25.2843L15.4156 19.6841Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M15.4156 19.6841C15.4156 19.6841 11.0489 23.1144 6.7002 25.2843\" stroke=\"#DB2D30\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M21.9704 20.0801C21.9704 20.0801 16.2532 24.87 10.2568 27.535L21.9704 20.0801Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M21.9704 20.0801C21.9704 20.0801 16.2532 24.87 10.2568 27.535\" stroke=\"#DB2D30\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M38.5363 19.8188H26.8227C25.6343 19.8188 24.6709 20.7823 24.6709 21.9707V25.1219C24.6709 26.3103 25.6343 27.2738 26.8227 27.2738H38.5363C39.7247 27.2738 40.6882 26.3103 40.6882 25.1219V21.9707C40.6882 20.7823 39.7247 19.8188 38.5363 19.8188Z\" stroke=\"#595757\" stroke-width=\"1.57\" stroke-miterlimit=\"10\"/>\n      <path d=\"M32.0176 19.6841C32.0176 19.6841 36.3843 23.1144 40.733 25.2843L32.0176 19.6841Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M32.0176 19.6841C32.0176 19.6841 36.3843 23.1144 40.733 25.2843\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25.4629 20.0801C25.4629 20.0801 31.1801 24.87 37.1765 27.535L25.4629 20.0801Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M25.4629 20.0801C25.4629 20.0801 31.1801 24.87 37.1765 27.535\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M39.1309 18.3335H8.23088C6.70432 18.3335 5.4668 19.571 5.4668 21.0976V25.8244C5.4668 27.351 6.70432 28.5885 8.23088 28.5885H39.1309C40.6575 28.5885 41.895 27.351 41.895 25.8244V21.0976C41.895 19.571 40.6575 18.3335 39.1309 18.3335Z\" stroke=\"#595757\" stroke-width=\"1.11\" stroke-miterlimit=\"10\"/>\n      <path d=\"M23.4913 11.9231C24.4908 11.9231 25.3011 11.1129 25.3011 10.1134C25.3011 9.11394 24.4908 8.30371 23.4913 8.30371C22.4919 8.30371 21.6816 9.11394 21.6816 10.1134C21.6816 11.1129 22.4919 11.9231 23.4913 11.9231Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M23.5094 47.0188C35.3887 47.0188 45.0188 37.3887 45.0188 25.5094C45.0188 13.6301 35.3887 4 23.5094 4C11.6301 4 2 13.6301 2 25.5094C2 37.3887 11.6301 47.0188 23.5094 47.0188Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M31.6519 17.1768L40.5712 13.3485C41.6968 12.8653 42.2177 11.5611 41.7345 10.4354L41.4541 9.78217C40.971 8.65651 39.6668 8.13566 38.5411 8.61881L29.6218 12.4471C28.4962 12.9303 27.9753 14.2345 28.4585 15.3602L28.7389 16.0134C29.222 17.1391 30.5262 17.66 31.6519 17.1768Z\" fill=\"#DB2D30\"/>\n      <path d=\"M39.7765 14.0994C41.7867 14.0994 43.4163 12.4698 43.4163 10.4596C43.4163 8.44942 41.7867 6.81982 39.7765 6.81982C37.7663 6.81982 36.1367 8.44942 36.1367 10.4596C36.1367 12.4698 37.7663 14.0994 39.7765 14.0994Z\" fill=\"#DB2D30\"/>\n      <path d=\"M48.9996 7.67315C48.9996 7.67315 42.4593 4.40301 40.2129 9.79637\" stroke=\"#DB2D30\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M42.4019 1C42.4019 1 36.3735 5.1327 40.0038 9.7109\" stroke=\"#DB2D30\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M31.151 16.1853C32.0305 16.1853 32.7434 15.4724 32.7434 14.5929C32.7434 13.7134 32.0305 13.0005 31.151 13.0005C30.2715 13.0005 29.5586 13.7134 29.5586 14.5929C29.5586 15.4724 30.2715 16.1853 31.151 16.1853Z\" stroke=\"white\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M39.777 12.052C40.6565 12.052 41.3694 11.3391 41.3694 10.4596C41.3694 9.58014 40.6565 8.86719 39.777 8.86719C38.8975 8.86719 38.1846 9.58014 38.1846 10.4596C38.1846 11.3391 38.8975 12.052 39.777 12.052Z\" stroke=\"white\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M14.1552 48.0004C18.9089 48.0004 22.7626 44.1467 22.7626 39.393C22.7626 34.6393 18.9089 30.7856 14.1552 30.7856C9.4015 30.7856 5.54785 34.6393 5.54785 39.393C5.54785 44.1467 9.4015 48.0004 14.1552 48.0004Z\" fill=\"#F5F5F5\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M33.0986 48.0004C37.8523 48.0004 41.7059 44.1467 41.7059 39.393C41.7059 34.6393 37.8523 30.7856 33.0986 30.7856C28.3449 30.7856 24.4912 34.6393 24.4912 39.393C24.4912 44.1467 28.3449 48.0004 33.0986 48.0004Z\" fill=\"#F5F5F5\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M14.1548 41.6435C15.3432 41.6435 16.3066 40.6801 16.3066 39.4917C16.3066 38.3033 15.3432 37.3398 14.1548 37.3398C12.9663 37.3398 12.0029 38.3033 12.0029 39.4917C12.0029 40.6801 12.9663 41.6435 14.1548 41.6435Z\" fill=\"#595757\"/>\n      <path d=\"M33.0981 41.5444C34.2866 41.5444 35.25 40.581 35.25 39.3926C35.25 38.2041 34.2866 37.2407 33.0981 37.2407C31.9097 37.2407 30.9463 38.2041 30.9463 39.3926C30.9463 40.581 31.9097 41.5444 33.0981 41.5444Z\" fill=\"#595757\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <mask id=\"path-1-inside-1_7029_3735\" fill=\"white\">\n      <rect width=\"12.2857\" height=\"5.43284\" rx=\"2\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 27.9385 14.1025)\"/>\n      </mask>\n      <rect width=\"12.2857\" height=\"5.43284\" rx=\"2\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 27.9385 14.1025)\" stroke=\"#595757\" stroke-width=\"4.2\" mask=\"url(#path-1-inside-1_7029_3735)\"/>\n      <rect x=\"1.13463\" y=\"0.951995\" width=\"46.4549\" height=\"12.113\" rx=\"2.95\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 -0.0759939 20.322)\" fill=\"white\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n      <path d=\"M42.233 31L45.1758 36.25H39.2902L42.233 31Z\" fill=\"#DB2D30\"/>\n      <path d=\"M49.9999 36H0.485352\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g clip-path=\"url(#clip0_7029_3768)\">\n      <path d=\"M15.0973 32.8968C18.8135 32.8968 21.8313 29.8799 21.8313 26.1583C21.8313 22.4367 18.8135 19.4199 15.0973 19.4199C11.3811 19.4199 8.36328 22.4367 8.36328 26.1583C8.36328 29.8799 11.3811 32.8968 15.0973 32.8968Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M15.0976 29.5448C16.9686 29.5448 18.4861 28.0321 18.4861 26.1584C18.4861 24.2847 16.9686 22.772 15.0976 22.772C13.2265 22.772 11.709 24.2847 11.709 26.1584C11.709 28.0321 13.2265 29.5448 15.0976 29.5448Z\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M33.7389 32.8968C37.4551 32.8968 40.4729 29.8799 40.4729 26.1583C40.4729 22.4367 37.4551 19.4199 33.7389 19.4199C30.0227 19.4199 27.0049 22.4367 27.0049 26.1583C27.0049 29.8799 30.0227 32.8968 33.7389 32.8968Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M33.7392 29.5448C35.6102 29.5448 37.1277 28.0321 37.1277 26.1584C37.1277 24.2847 35.6102 22.772 33.7392 22.772C31.8681 22.772 30.3506 24.2847 30.3506 26.1584C30.3506 28.0321 31.8681 29.5448 33.7392 29.5448Z\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M41.8864 18.3458C42.6796 18.3458 43.3177 17.7012 43.3177 16.9104C43.3177 16.1197 42.6796 15.4751 41.8864 15.4751C41.0931 15.4751 40.4551 16.1197 40.4551 16.9104C40.4551 17.7012 41.0931 18.3458 41.8864 18.3458Z\" fill=\"#EA0029\" stroke=\"#EA0029\" stroke-width=\"1.49\" stroke-miterlimit=\"10\"/>\n      <path d=\"M44.8183 10.9023H5.19018C3.92826 10.9023 2.90527 11.9221 2.90527 13.18V37.4864C2.90527 38.7443 3.92826 39.7641 5.19018 39.7641H44.8183C46.0802 39.7641 47.1032 38.7443 47.1032 37.4864V13.18C47.1032 11.9221 46.0802 10.9023 44.8183 10.9023Z\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n      </g>\n      <defs>\n      <clipPath id=\"clip0_7029_3768\">\n      <rect width=\"46\" height=\"30.6667\" fill=\"white\" transform=\"translate(2 10)\"/>\n      </clipPath>\n      </defs>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M17.2117 16.8871C17.4285 17.251 17.3588 17.7157 17.0336 17.9789C16.236 18.6372 15.6552 19.5122 15.3609 20.5189C15.0667 21.5256 15.0899 22.5787 15.4151 23.5622C15.5468 23.9649 15.3609 24.3985 14.9815 24.5844C14.5169 24.8167 13.9438 24.5844 13.789 24.0965C13.3553 22.7878 13.3321 21.3785 13.7193 20.0388C14.1065 18.6991 14.8886 17.5221 15.9495 16.6548C16.3521 16.3295 16.9484 16.4457 17.2194 16.8871H17.2117Z\" fill=\"#595757\"/>\n      <path d=\"M15.0181 12.2926C15.2659 12.6798 15.1575 13.1831 14.7858 13.4619C12.7492 14.9797 11.3321 17.055 10.581 19.6414C9.82983 22.2278 9.90726 24.7368 10.821 27.1141C10.9836 27.5478 10.8133 28.0279 10.3951 28.2215C9.93824 28.4306 9.40392 28.206 9.22581 27.7336C8.1959 25.0233 8.08748 22.0807 8.9393 19.1613C9.78336 16.2419 11.4483 13.8104 13.7714 12.0758C14.1741 11.7738 14.7471 11.8667 15.0181 12.2926Z\" fill=\"#595757\"/>\n      <path d=\"M32.991 16.8871C32.7742 17.251 32.8439 17.7157 33.1691 17.9789C33.9667 18.6372 34.5475 19.5122 34.8418 20.5189C35.136 21.5256 35.1128 22.5787 34.7876 23.5622C34.6559 23.9649 34.8418 24.3985 35.2212 24.5844C35.6858 24.8167 36.2589 24.5844 36.4137 24.0965C36.8474 22.7878 36.8706 21.3785 36.4834 20.0388C36.0963 18.6991 35.3141 17.5221 34.2532 16.6548C33.8506 16.3295 33.2543 16.4457 32.9833 16.8871H32.991Z\" fill=\"#595757\"/>\n      <path d=\"M34.9821 12.2926C34.7343 12.6798 34.8427 13.1831 35.2144 13.4619C37.251 14.9797 38.6681 17.055 39.4193 19.6414C40.1704 22.2278 40.093 24.7368 39.1792 27.1141C39.0166 27.5478 39.187 28.0279 39.6051 28.2215C40.062 28.4306 40.5963 28.206 40.7744 27.7336C41.8044 25.0233 41.9128 22.0807 41.061 19.1613C40.2169 16.2419 38.552 13.8104 36.2289 12.0758C35.8262 11.7738 35.2532 11.8667 34.9821 12.2926Z\" fill=\"#595757\"/>\n      <path d=\"M24.7416 36.1292C19.484 36.1292 15.1232 32.6468 14.4022 28.137C14.2879 27.439 14.9122 26.8115 15.7034 26.8115C16.3452 26.8115 16.8904 27.2351 16.9871 27.7998C17.5322 31.188 20.8028 33.7919 24.7416 33.7919C28.6804 33.7919 31.9511 31.1801 32.4962 27.7998C32.5841 27.2272 33.1292 26.8115 33.7798 26.8115C34.5711 26.8115 35.1953 27.439 35.081 28.137C34.3601 32.6468 29.9992 36.1292 24.7416 36.1292Z\" fill=\"#DB2D30\"/>\n      <path d=\"M24.7409 30.9531C21.8825 30.9531 19.5645 28.7896 19.5645 26.1217V21.2904C19.5645 18.6225 21.8825 16.459 24.7409 16.459C27.5993 16.459 29.9174 18.6225 29.9174 21.2904V26.1217C29.9174 28.7896 27.5993 30.9531 24.7409 30.9531ZM24.7409 18.8747C23.3117 18.8747 22.1527 19.9564 22.1527 21.2904V26.1217C22.1527 27.4556 23.3117 28.5374 24.7409 28.5374C26.1701 28.5374 27.3292 27.4556 27.3292 26.1217V21.2904C27.3292 19.9564 26.1701 18.8747 24.7409 18.8747Z\" fill=\"#DB2D30\"/>\n      <path d=\"M24.8076 35.0942H24.6751C24.1399 35.0942 23.7061 35.6152 23.7061 36.2579V40.1423C23.7061 40.785 24.1399 41.306 24.6751 41.306H24.8076C25.3428 41.306 25.7766 40.785 25.7766 40.1423V36.2579C25.7766 35.6152 25.3428 35.0942 24.8076 35.0942Z\" fill=\"#DB2D30\"/>\n      <path d=\"M25 47C37.1503 47 47 37.1503 47 25C47 12.8497 37.1503 3 25 3C12.8497 3 3 12.8497 3 25C3 37.1503 12.8497 47 25 47Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g clip-path=\"url(#clip0_3013_2274)\">\n      <path d=\"M21.6381 5.04273V19.6901H8.95225V5.04273H21.6381ZM22.3925 3H8.19783C7.48984 3 6.90952 3.55711 6.90952 4.2535V20.4909C6.90952 21.1757 7.48984 21.7444 8.19783 21.7444H22.3809C23.0889 21.7444 23.6692 21.1873 23.6692 20.4909V4.2535C23.6692 3.56872 23.0889 3 22.3809 3H22.3925Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.545 5.04273V19.6901H27.8591V5.04273H40.545ZM41.2994 3H27.1163C26.4083 3 25.828 3.55711 25.828 4.2535V20.4909C25.828 21.1757 26.4083 21.7444 27.1163 21.7444H41.2994C42.0074 21.7444 42.5877 21.1873 42.5877 20.4909V4.2535C42.5877 3.56872 42.0074 3 41.2994 3Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.5566 24.9138V29.893H8.95225V24.9138H40.5566ZM41.2762 22.8711H8.23265C7.50144 22.8711 6.90952 23.3237 6.90952 23.8809V30.926C6.90952 31.4831 7.50144 31.9357 8.23265 31.9357H41.2762C42.0074 31.9357 42.5993 31.4831 42.5993 30.926V23.8809C42.5993 23.3237 42.0074 22.8711 41.2762 22.8711Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.5566 35.0584V36.0101H8.95225V35.0584H40.5566ZM41.2762 33.0156H8.23265C7.50144 33.0156 6.90952 33.4683 6.90952 34.0254V37.0431C6.90952 37.6002 7.50144 38.0528 8.23265 38.0528H41.2762C42.0074 38.0528 42.5993 37.6002 42.5993 37.0431V34.0254C42.5993 33.4683 42.0074 33.0156 41.2762 33.0156Z\" fill=\"#595757\"/>\n      <path d=\"M42.2047 42.4255L44.5376 44.9441H4.97124L7.30414 42.4255H42.1931M42.5065 40.3828H6.99076C6.61936 40.3828 6.27116 40.5337 6.01582 40.8123L2.34819 44.7817C1.57056 45.6289 2.16248 46.9985 3.32313 46.9985H46.1857C47.3347 46.9985 47.9383 45.6289 47.1606 44.7817L43.493 40.8123C43.2377 40.5453 42.8895 40.3828 42.5181 40.3828H42.5065Z\" fill=\"#595757\"/>\n      </g>\n      <defs>\n      <clipPath id=\"clip0_3013_2274\">\n      <rect width=\"45.5088\" height=\"44\" fill=\"white\" transform=\"translate(2 3)\"/>\n      </clipPath>\n      </defs>\n    </svg>"],
  "item2": ["<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M25 47C37.1462 47 47 37.1462 47 25C47 12.8538 37.1462 3 25 3C12.8538 3 3 12.8449 3 25C3 37.1551 12.8538 47 25 47Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M35.3692 13.458C35.3692 13.458 32.4815 14 30.3224 16.6123C28.3409 19.0469 28.4298 21.2149 28.4298 21.2149\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M24.547 9.49512C24.547 9.49512 22.8321 11.8408 23.1076 15.2617C23.3741 18.416 24.9113 19.9531 24.9113 19.9531\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M13.5469 14.5422C13.5469 14.5422 14.0889 17.43 16.7012 19.5891C19.1357 21.6594 21.3037 21.4817 21.3037 21.4817\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M9.49512 25.178C9.49512 25.178 11.8408 26.8928 15.2617 26.7151C18.416 26.5374 19.9531 25.0002 19.9531 25.0002\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M14.6309 36.3645C14.6309 36.3645 17.5186 35.8225 19.6777 33.2102C21.6591 30.7757 21.5703 28.6077 21.5703 28.6077\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25.4532 40.4162C25.4532 40.4162 27.168 38.0705 26.8926 34.6497C26.626 31.4954 25.0889 29.9583 25.0889 29.9583\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M36.4532 35.3693C36.4532 35.3693 35.9112 32.4815 33.2989 30.3224C30.8643 28.2521 28.6963 28.4298 28.6963 28.4298\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M40.416 24.7337C40.416 24.7337 38.0703 23.0188 34.6494 23.1965C31.4952 23.3742 29.958 24.9114 29.958 24.9114\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25 30.0468C27.79 30.0468 30.0468 27.79 30.0468 25C30.0468 22.21 27.79 19.9531 25 19.9531C22.21 19.9531 19.9531 22.21 19.9531 25C19.9531 27.79 22.21 30.0468 25 30.0468Z\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25 40.5048C33.5654 40.5048 40.5048 33.5654 40.5048 25C40.5048 16.4345 33.5654 9.49512 25 9.49512C16.4345 9.49512 9.49512 16.4345 9.49512 25C9.49512 33.5654 16.4345 40.5048 25 40.5048Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M20.5656 19.8188H8.85204C7.66361 19.8188 6.7002 20.7823 6.7002 21.9707V25.1219C6.7002 26.3103 7.66361 27.2738 8.85204 27.2738H20.5656C21.754 27.2738 22.7175 26.3103 22.7175 25.1219V21.9707C22.7175 20.7823 21.754 19.8188 20.5656 19.8188Z\" stroke=\"#DB2D30\" stroke-width=\"1.57\" stroke-miterlimit=\"10\"/>\n      <path d=\"M15.4156 19.6841C15.4156 19.6841 11.0489 23.1144 6.7002 25.2843L15.4156 19.6841Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M15.4156 19.6841C15.4156 19.6841 11.0489 23.1144 6.7002 25.2843\" stroke=\"#DB2D30\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M21.9704 20.0801C21.9704 20.0801 16.2532 24.87 10.2568 27.535L21.9704 20.0801Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M21.9704 20.0801C21.9704 20.0801 16.2532 24.87 10.2568 27.535\" stroke=\"#DB2D30\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M38.5363 19.8188H26.8227C25.6343 19.8188 24.6709 20.7823 24.6709 21.9707V25.1219C24.6709 26.3103 25.6343 27.2738 26.8227 27.2738H38.5363C39.7247 27.2738 40.6882 26.3103 40.6882 25.1219V21.9707C40.6882 20.7823 39.7247 19.8188 38.5363 19.8188Z\" stroke=\"#595757\" stroke-width=\"1.57\" stroke-miterlimit=\"10\"/>\n      <path d=\"M32.0176 19.6841C32.0176 19.6841 36.3843 23.1144 40.733 25.2843L32.0176 19.6841Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M32.0176 19.6841C32.0176 19.6841 36.3843 23.1144 40.733 25.2843\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25.4629 20.0801C25.4629 20.0801 31.1801 24.87 37.1765 27.535L25.4629 20.0801Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M25.4629 20.0801C25.4629 20.0801 31.1801 24.87 37.1765 27.535\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M39.1309 18.3335H8.23088C6.70432 18.3335 5.4668 19.571 5.4668 21.0976V25.8244C5.4668 27.351 6.70432 28.5885 8.23088 28.5885H39.1309C40.6575 28.5885 41.895 27.351 41.895 25.8244V21.0976C41.895 19.571 40.6575 18.3335 39.1309 18.3335Z\" stroke=\"#595757\" stroke-width=\"1.11\" stroke-miterlimit=\"10\"/>\n      <path d=\"M23.4913 11.9231C24.4908 11.9231 25.3011 11.1129 25.3011 10.1134C25.3011 9.11394 24.4908 8.30371 23.4913 8.30371C22.4919 8.30371 21.6816 9.11394 21.6816 10.1134C21.6816 11.1129 22.4919 11.9231 23.4913 11.9231Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M23.5094 47.0188C35.3887 47.0188 45.0188 37.3887 45.0188 25.5094C45.0188 13.6301 35.3887 4 23.5094 4C11.6301 4 2 13.6301 2 25.5094C2 37.3887 11.6301 47.0188 23.5094 47.0188Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M31.6519 17.1768L40.5712 13.3485C41.6968 12.8653 42.2177 11.5611 41.7345 10.4354L41.4541 9.78217C40.971 8.65651 39.6668 8.13566 38.5411 8.61881L29.6218 12.4471C28.4962 12.9303 27.9753 14.2345 28.4585 15.3602L28.7389 16.0134C29.222 17.1391 30.5262 17.66 31.6519 17.1768Z\" fill=\"#DB2D30\"/>\n      <path d=\"M39.7765 14.0994C41.7867 14.0994 43.4163 12.4698 43.4163 10.4596C43.4163 8.44942 41.7867 6.81982 39.7765 6.81982C37.7663 6.81982 36.1367 8.44942 36.1367 10.4596C36.1367 12.4698 37.7663 14.0994 39.7765 14.0994Z\" fill=\"#DB2D30\"/>\n      <path d=\"M48.9996 7.67315C48.9996 7.67315 42.4593 4.40301 40.2129 9.79637\" stroke=\"#DB2D30\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M42.4019 1C42.4019 1 36.3735 5.1327 40.0038 9.7109\" stroke=\"#DB2D30\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M31.151 16.1853C32.0305 16.1853 32.7434 15.4724 32.7434 14.5929C32.7434 13.7134 32.0305 13.0005 31.151 13.0005C30.2715 13.0005 29.5586 13.7134 29.5586 14.5929C29.5586 15.4724 30.2715 16.1853 31.151 16.1853Z\" stroke=\"white\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M39.777 12.052C40.6565 12.052 41.3694 11.3391 41.3694 10.4596C41.3694 9.58014 40.6565 8.86719 39.777 8.86719C38.8975 8.86719 38.1846 9.58014 38.1846 10.4596C38.1846 11.3391 38.8975 12.052 39.777 12.052Z\" stroke=\"white\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M14.1552 48.0004C18.9089 48.0004 22.7626 44.1467 22.7626 39.393C22.7626 34.6393 18.9089 30.7856 14.1552 30.7856C9.4015 30.7856 5.54785 34.6393 5.54785 39.393C5.54785 44.1467 9.4015 48.0004 14.1552 48.0004Z\" fill=\"#F5F5F5\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M33.0986 48.0004C37.8523 48.0004 41.7059 44.1467 41.7059 39.393C41.7059 34.6393 37.8523 30.7856 33.0986 30.7856C28.3449 30.7856 24.4912 34.6393 24.4912 39.393C24.4912 44.1467 28.3449 48.0004 33.0986 48.0004Z\" fill=\"#F5F5F5\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M14.1548 41.6435C15.3432 41.6435 16.3066 40.6801 16.3066 39.4917C16.3066 38.3033 15.3432 37.3398 14.1548 37.3398C12.9663 37.3398 12.0029 38.3033 12.0029 39.4917C12.0029 40.6801 12.9663 41.6435 14.1548 41.6435Z\" fill=\"#595757\"/>\n      <path d=\"M33.0981 41.5444C34.2866 41.5444 35.25 40.581 35.25 39.3926C35.25 38.2041 34.2866 37.2407 33.0981 37.2407C31.9097 37.2407 30.9463 38.2041 30.9463 39.3926C30.9463 40.581 31.9097 41.5444 33.0981 41.5444Z\" fill=\"#595757\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <mask id=\"path-1-inside-1_7029_3735\" fill=\"white\">\n      <rect width=\"12.2857\" height=\"5.43284\" rx=\"2\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 27.9385 14.1025)\"/>\n      </mask>\n      <rect width=\"12.2857\" height=\"5.43284\" rx=\"2\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 27.9385 14.1025)\" stroke=\"#595757\" stroke-width=\"4.2\" mask=\"url(#path-1-inside-1_7029_3735)\"/>\n      <rect x=\"1.13463\" y=\"0.951995\" width=\"46.4549\" height=\"12.113\" rx=\"2.95\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 -0.0759939 20.322)\" fill=\"white\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n      <path d=\"M42.233 31L45.1758 36.25H39.2902L42.233 31Z\" fill=\"#DB2D30\"/>\n      <path d=\"M49.9999 36H0.485352\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g clip-path=\"url(#clip0_7021_1007)\">\n      <path d=\"M18.734 32.8968C22.4502 32.8968 25.468 29.8799 25.468 26.1583C25.468 22.4367 22.4502 19.4199 18.734 19.4199C15.0178 19.4199 12 22.4367 12 26.1583C12 29.8799 15.0178 32.8968 18.734 32.8968Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M18.734 29.5448C20.6051 29.5448 22.1226 28.0321 22.1226 26.1584C22.1226 24.2847 20.6051 22.772 18.734 22.772C16.863 22.772 15.3455 24.2847 15.3455 26.1584C15.3455 28.0321 16.863 29.5448 18.734 29.5448Z\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M35.4313 26.8707C36.2246 26.8707 36.8626 26.2261 36.8626 25.4354C36.8626 24.6446 36.2246 24 35.4313 24C34.6381 24 34 24.6446 34 25.4354C34 26.2261 34.6381 26.8707 35.4313 26.8707Z\" fill=\"#EA0029\" stroke=\"#EA0029\" stroke-width=\"1.49\" stroke-miterlimit=\"10\"/>\n      <path d=\"M44.8184 10.9023H5.19031C3.92839 10.9023 2.9054 11.9221 2.9054 13.18V37.4864C2.9054 38.7443 3.92839 39.7641 5.19031 39.7641H44.8184C46.0803 39.7641 47.1033 38.7443 47.1033 37.4864V13.18C47.1033 11.9221 46.0803 10.9023 44.8184 10.9023Z\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n      </g>\n      <defs>\n      <clipPath id=\"clip0_7021_1007\">\n      <rect width=\"46\" height=\"30.6667\" fill=\"white\" transform=\"translate(2 10)\"/>\n      </clipPath>\n      </defs>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M17.2117 16.8871C17.4285 17.251 17.3588 17.7157 17.0336 17.9789C16.236 18.6372 15.6552 19.5122 15.3609 20.5189C15.0667 21.5256 15.0899 22.5787 15.4151 23.5622C15.5468 23.9649 15.3609 24.3985 14.9815 24.5844C14.5169 24.8167 13.9438 24.5844 13.789 24.0965C13.3553 22.7878 13.3321 21.3785 13.7193 20.0388C14.1065 18.6991 14.8886 17.5221 15.9495 16.6548C16.3521 16.3295 16.9484 16.4457 17.2194 16.8871H17.2117Z\" fill=\"#595757\"/>\n      <path d=\"M15.0181 12.2926C15.2659 12.6798 15.1575 13.1831 14.7858 13.4619C12.7492 14.9797 11.3321 17.055 10.581 19.6414C9.82983 22.2278 9.90726 24.7368 10.821 27.1141C10.9836 27.5478 10.8133 28.0279 10.3951 28.2215C9.93824 28.4306 9.40392 28.206 9.22581 27.7336C8.1959 25.0233 8.08748 22.0807 8.9393 19.1613C9.78336 16.2419 11.4483 13.8104 13.7714 12.0758C14.1741 11.7738 14.7471 11.8667 15.0181 12.2926Z\" fill=\"#595757\"/>\n      <path d=\"M32.991 16.8871C32.7742 17.251 32.8439 17.7157 33.1691 17.9789C33.9667 18.6372 34.5475 19.5122 34.8418 20.5189C35.136 21.5256 35.1128 22.5787 34.7876 23.5622C34.6559 23.9649 34.8418 24.3985 35.2212 24.5844C35.6858 24.8167 36.2589 24.5844 36.4137 24.0965C36.8474 22.7878 36.8706 21.3785 36.4834 20.0388C36.0963 18.6991 35.3141 17.5221 34.2532 16.6548C33.8506 16.3295 33.2543 16.4457 32.9833 16.8871H32.991Z\" fill=\"#595757\"/>\n      <path d=\"M34.9821 12.2926C34.7343 12.6798 34.8427 13.1831 35.2144 13.4619C37.251 14.9797 38.6681 17.055 39.4193 19.6414C40.1704 22.2278 40.093 24.7368 39.1792 27.1141C39.0166 27.5478 39.187 28.0279 39.6051 28.2215C40.062 28.4306 40.5963 28.206 40.7744 27.7336C41.8044 25.0233 41.9128 22.0807 41.061 19.1613C40.2169 16.2419 38.552 13.8104 36.2289 12.0758C35.8262 11.7738 35.2532 11.8667 34.9821 12.2926Z\" fill=\"#595757\"/>\n      <path d=\"M24.7416 36.1292C19.484 36.1292 15.1232 32.6468 14.4022 28.137C14.2879 27.439 14.9122 26.8115 15.7034 26.8115C16.3452 26.8115 16.8904 27.2351 16.9871 27.7998C17.5322 31.188 20.8028 33.7919 24.7416 33.7919C28.6804 33.7919 31.9511 31.1801 32.4962 27.7998C32.5841 27.2272 33.1292 26.8115 33.7798 26.8115C34.5711 26.8115 35.1953 27.439 35.081 28.137C34.3601 32.6468 29.9992 36.1292 24.7416 36.1292Z\" fill=\"#DB2D30\"/>\n      <path d=\"M24.7409 30.9531C21.8825 30.9531 19.5645 28.7896 19.5645 26.1217V21.2904C19.5645 18.6225 21.8825 16.459 24.7409 16.459C27.5993 16.459 29.9174 18.6225 29.9174 21.2904V26.1217C29.9174 28.7896 27.5993 30.9531 24.7409 30.9531ZM24.7409 18.8747C23.3117 18.8747 22.1527 19.9564 22.1527 21.2904V26.1217C22.1527 27.4556 23.3117 28.5374 24.7409 28.5374C26.1701 28.5374 27.3292 27.4556 27.3292 26.1217V21.2904C27.3292 19.9564 26.1701 18.8747 24.7409 18.8747Z\" fill=\"#DB2D30\"/>\n      <path d=\"M24.8076 35.0942H24.6751C24.1399 35.0942 23.7061 35.6152 23.7061 36.2579V40.1423C23.7061 40.785 24.1399 41.306 24.6751 41.306H24.8076C25.3428 41.306 25.7766 40.785 25.7766 40.1423V36.2579C25.7766 35.6152 25.3428 35.0942 24.8076 35.0942Z\" fill=\"#DB2D30\"/>\n      <path d=\"M25 47C37.1503 47 47 37.1503 47 25C47 12.8497 37.1503 3 25 3C12.8497 3 3 12.8497 3 25C3 37.1503 12.8497 47 25 47Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g clip-path=\"url(#clip0_3013_2274)\">\n      <path d=\"M21.6381 5.04273V19.6901H8.95225V5.04273H21.6381ZM22.3925 3H8.19783C7.48984 3 6.90952 3.55711 6.90952 4.2535V20.4909C6.90952 21.1757 7.48984 21.7444 8.19783 21.7444H22.3809C23.0889 21.7444 23.6692 21.1873 23.6692 20.4909V4.2535C23.6692 3.56872 23.0889 3 22.3809 3H22.3925Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.545 5.04273V19.6901H27.8591V5.04273H40.545ZM41.2994 3H27.1163C26.4083 3 25.828 3.55711 25.828 4.2535V20.4909C25.828 21.1757 26.4083 21.7444 27.1163 21.7444H41.2994C42.0074 21.7444 42.5877 21.1873 42.5877 20.4909V4.2535C42.5877 3.56872 42.0074 3 41.2994 3Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.5566 24.9138V29.893H8.95225V24.9138H40.5566ZM41.2762 22.8711H8.23265C7.50144 22.8711 6.90952 23.3237 6.90952 23.8809V30.926C6.90952 31.4831 7.50144 31.9357 8.23265 31.9357H41.2762C42.0074 31.9357 42.5993 31.4831 42.5993 30.926V23.8809C42.5993 23.3237 42.0074 22.8711 41.2762 22.8711Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.5566 35.0584V36.0101H8.95225V35.0584H40.5566ZM41.2762 33.0156H8.23265C7.50144 33.0156 6.90952 33.4683 6.90952 34.0254V37.0431C6.90952 37.6002 7.50144 38.0528 8.23265 38.0528H41.2762C42.0074 38.0528 42.5993 37.6002 42.5993 37.0431V34.0254C42.5993 33.4683 42.0074 33.0156 41.2762 33.0156Z\" fill=\"#595757\"/>\n      <path d=\"M42.2047 42.4255L44.5376 44.9441H4.97124L7.30414 42.4255H42.1931M42.5065 40.3828H6.99076C6.61936 40.3828 6.27116 40.5337 6.01582 40.8123L2.34819 44.7817C1.57056 45.6289 2.16248 46.9985 3.32313 46.9985H46.1857C47.3347 46.9985 47.9383 45.6289 47.1606 44.7817L43.493 40.8123C43.2377 40.5453 42.8895 40.3828 42.5181 40.3828H42.5065Z\" fill=\"#595757\"/>\n      </g>\n      <defs>\n      <clipPath id=\"clip0_3013_2274\">\n      <rect width=\"45.5088\" height=\"44\" fill=\"white\" transform=\"translate(2 3)\"/>\n      </clipPath>\n      </defs>\n    </svg>"],
  "item3": ["<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M25 47C37.1462 47 47 37.1462 47 25C47 12.8538 37.1462 3 25 3C12.8538 3 3 12.8449 3 25C3 37.1551 12.8538 47 25 47Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M35.3692 13.458C35.3692 13.458 32.4815 14 30.3224 16.6123C28.3409 19.0469 28.4298 21.2149 28.4298 21.2149\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M24.547 9.49512C24.547 9.49512 22.8321 11.8408 23.1076 15.2617C23.3741 18.416 24.9113 19.9531 24.9113 19.9531\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M13.5469 14.5422C13.5469 14.5422 14.0889 17.43 16.7012 19.5891C19.1357 21.6594 21.3037 21.4817 21.3037 21.4817\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M9.49512 25.178C9.49512 25.178 11.8408 26.8928 15.2617 26.7151C18.416 26.5374 19.9531 25.0002 19.9531 25.0002\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M14.6309 36.3645C14.6309 36.3645 17.5186 35.8225 19.6777 33.2102C21.6591 30.7757 21.5703 28.6077 21.5703 28.6077\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25.4532 40.4162C25.4532 40.4162 27.168 38.0705 26.8926 34.6497C26.626 31.4954 25.0889 29.9583 25.0889 29.9583\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M36.4532 35.3693C36.4532 35.3693 35.9112 32.4815 33.2989 30.3224C30.8643 28.2521 28.6963 28.4298 28.6963 28.4298\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M40.416 24.7337C40.416 24.7337 38.0703 23.0188 34.6494 23.1965C31.4952 23.3742 29.958 24.9114 29.958 24.9114\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25 30.0468C27.79 30.0468 30.0468 27.79 30.0468 25C30.0468 22.21 27.79 19.9531 25 19.9531C22.21 19.9531 19.9531 22.21 19.9531 25C19.9531 27.79 22.21 30.0468 25 30.0468Z\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25 40.5048C33.5654 40.5048 40.5048 33.5654 40.5048 25C40.5048 16.4345 33.5654 9.49512 25 9.49512C16.4345 9.49512 9.49512 16.4345 9.49512 25C9.49512 33.5654 16.4345 40.5048 25 40.5048Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M20.5656 19.8188H8.85204C7.66361 19.8188 6.7002 20.7823 6.7002 21.9707V25.1219C6.7002 26.3103 7.66361 27.2738 8.85204 27.2738H20.5656C21.754 27.2738 22.7175 26.3103 22.7175 25.1219V21.9707C22.7175 20.7823 21.754 19.8188 20.5656 19.8188Z\" stroke=\"#DB2D30\" stroke-width=\"1.57\" stroke-miterlimit=\"10\"/>\n      <path d=\"M15.4156 19.6841C15.4156 19.6841 11.0489 23.1144 6.7002 25.2843L15.4156 19.6841Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M15.4156 19.6841C15.4156 19.6841 11.0489 23.1144 6.7002 25.2843\" stroke=\"#DB2D30\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M21.9704 20.0801C21.9704 20.0801 16.2532 24.87 10.2568 27.535L21.9704 20.0801Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M21.9704 20.0801C21.9704 20.0801 16.2532 24.87 10.2568 27.535\" stroke=\"#DB2D30\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M38.5363 19.8188H26.8227C25.6343 19.8188 24.6709 20.7823 24.6709 21.9707V25.1219C24.6709 26.3103 25.6343 27.2738 26.8227 27.2738H38.5363C39.7247 27.2738 40.6882 26.3103 40.6882 25.1219V21.9707C40.6882 20.7823 39.7247 19.8188 38.5363 19.8188Z\" stroke=\"#595757\" stroke-width=\"1.57\" stroke-miterlimit=\"10\"/>\n      <path d=\"M32.0176 19.6841C32.0176 19.6841 36.3843 23.1144 40.733 25.2843L32.0176 19.6841Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M32.0176 19.6841C32.0176 19.6841 36.3843 23.1144 40.733 25.2843\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25.4629 20.0801C25.4629 20.0801 31.1801 24.87 37.1765 27.535L25.4629 20.0801Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M25.4629 20.0801C25.4629 20.0801 31.1801 24.87 37.1765 27.535\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M39.1309 18.3335H8.23088C6.70432 18.3335 5.4668 19.571 5.4668 21.0976V25.8244C5.4668 27.351 6.70432 28.5885 8.23088 28.5885H39.1309C40.6575 28.5885 41.895 27.351 41.895 25.8244V21.0976C41.895 19.571 40.6575 18.3335 39.1309 18.3335Z\" stroke=\"#595757\" stroke-width=\"1.11\" stroke-miterlimit=\"10\"/>\n      <path d=\"M23.4913 11.9231C24.4908 11.9231 25.3011 11.1129 25.3011 10.1134C25.3011 9.11394 24.4908 8.30371 23.4913 8.30371C22.4919 8.30371 21.6816 9.11394 21.6816 10.1134C21.6816 11.1129 22.4919 11.9231 23.4913 11.9231Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M23.5094 47.0188C35.3887 47.0188 45.0188 37.3887 45.0188 25.5094C45.0188 13.6301 35.3887 4 23.5094 4C11.6301 4 2 13.6301 2 25.5094C2 37.3887 11.6301 47.0188 23.5094 47.0188Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M31.6519 17.1768L40.5712 13.3485C41.6968 12.8653 42.2177 11.5611 41.7345 10.4354L41.4541 9.78217C40.971 8.65651 39.6668 8.13566 38.5411 8.61881L29.6218 12.4471C28.4962 12.9303 27.9753 14.2345 28.4585 15.3602L28.7389 16.0134C29.222 17.1391 30.5262 17.66 31.6519 17.1768Z\" fill=\"#DB2D30\"/>\n      <path d=\"M39.7765 14.0994C41.7867 14.0994 43.4163 12.4698 43.4163 10.4596C43.4163 8.44942 41.7867 6.81982 39.7765 6.81982C37.7663 6.81982 36.1367 8.44942 36.1367 10.4596C36.1367 12.4698 37.7663 14.0994 39.7765 14.0994Z\" fill=\"#DB2D30\"/>\n      <path d=\"M48.9996 7.67315C48.9996 7.67315 42.4593 4.40301 40.2129 9.79637\" stroke=\"#DB2D30\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M42.4019 1C42.4019 1 36.3735 5.1327 40.0038 9.7109\" stroke=\"#DB2D30\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M31.151 16.1853C32.0305 16.1853 32.7434 15.4724 32.7434 14.5929C32.7434 13.7134 32.0305 13.0005 31.151 13.0005C30.2715 13.0005 29.5586 13.7134 29.5586 14.5929C29.5586 15.4724 30.2715 16.1853 31.151 16.1853Z\" stroke=\"white\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M39.777 12.052C40.6565 12.052 41.3694 11.3391 41.3694 10.4596C41.3694 9.58014 40.6565 8.86719 39.777 8.86719C38.8975 8.86719 38.1846 9.58014 38.1846 10.4596C38.1846 11.3391 38.8975 12.052 39.777 12.052Z\" stroke=\"white\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M14.1552 48.0004C18.9089 48.0004 22.7626 44.1467 22.7626 39.393C22.7626 34.6393 18.9089 30.7856 14.1552 30.7856C9.4015 30.7856 5.54785 34.6393 5.54785 39.393C5.54785 44.1467 9.4015 48.0004 14.1552 48.0004Z\" fill=\"#F5F5F5\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M33.0986 48.0004C37.8523 48.0004 41.7059 44.1467 41.7059 39.393C41.7059 34.6393 37.8523 30.7856 33.0986 30.7856C28.3449 30.7856 24.4912 34.6393 24.4912 39.393C24.4912 44.1467 28.3449 48.0004 33.0986 48.0004Z\" fill=\"#F5F5F5\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M14.1548 41.6435C15.3432 41.6435 16.3066 40.6801 16.3066 39.4917C16.3066 38.3033 15.3432 37.3398 14.1548 37.3398C12.9663 37.3398 12.0029 38.3033 12.0029 39.4917C12.0029 40.6801 12.9663 41.6435 14.1548 41.6435Z\" fill=\"#595757\"/>\n      <path d=\"M33.0981 41.5444C34.2866 41.5444 35.25 40.581 35.25 39.3926C35.25 38.2041 34.2866 37.2407 33.0981 37.2407C31.9097 37.2407 30.9463 38.2041 30.9463 39.3926C30.9463 40.581 31.9097 41.5444 33.0981 41.5444Z\" fill=\"#595757\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <mask id=\"path-1-inside-1_7029_3735\" fill=\"white\">\n      <rect width=\"12.2857\" height=\"5.43284\" rx=\"2\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 27.9385 14.1025)\"/>\n      </mask>\n      <rect width=\"12.2857\" height=\"5.43284\" rx=\"2\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 27.9385 14.1025)\" stroke=\"#595757\" stroke-width=\"4.2\" mask=\"url(#path-1-inside-1_7029_3735)\"/>\n      <rect x=\"1.13463\" y=\"0.951995\" width=\"46.4549\" height=\"12.113\" rx=\"2.95\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 -0.0759939 20.322)\" fill=\"white\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n      <path d=\"M42.233 31L45.1758 36.25H39.2902L42.233 31Z\" fill=\"#DB2D30\"/>\n      <path d=\"M49.9999 36H0.485352\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g clip-path=\"url(#clip0_7021_1007)\">\n      <path d=\"M18.734 32.8968C22.4502 32.8968 25.468 29.8799 25.468 26.1583C25.468 22.4367 22.4502 19.4199 18.734 19.4199C15.0178 19.4199 12 22.4367 12 26.1583C12 29.8799 15.0178 32.8968 18.734 32.8968Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M18.734 29.5448C20.6051 29.5448 22.1226 28.0321 22.1226 26.1584C22.1226 24.2847 20.6051 22.772 18.734 22.772C16.863 22.772 15.3455 24.2847 15.3455 26.1584C15.3455 28.0321 16.863 29.5448 18.734 29.5448Z\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M35.4313 26.8707C36.2246 26.8707 36.8626 26.2261 36.8626 25.4354C36.8626 24.6446 36.2246 24 35.4313 24C34.6381 24 34 24.6446 34 25.4354C34 26.2261 34.6381 26.8707 35.4313 26.8707Z\" fill=\"#EA0029\" stroke=\"#EA0029\" stroke-width=\"1.49\" stroke-miterlimit=\"10\"/>\n      <path d=\"M44.8184 10.9023H5.19031C3.92839 10.9023 2.9054 11.9221 2.9054 13.18V37.4864C2.9054 38.7443 3.92839 39.7641 5.19031 39.7641H44.8184C46.0803 39.7641 47.1033 38.7443 47.1033 37.4864V13.18C47.1033 11.9221 46.0803 10.9023 44.8184 10.9023Z\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n      </g>\n      <defs>\n      <clipPath id=\"clip0_7021_1007\">\n      <rect width=\"46\" height=\"30.6667\" fill=\"white\" transform=\"translate(2 10)\"/>\n      </clipPath>\n      </defs>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M17.2117 16.8871C17.4285 17.251 17.3588 17.7157 17.0336 17.9789C16.236 18.6372 15.6552 19.5122 15.3609 20.5189C15.0667 21.5256 15.0899 22.5787 15.4151 23.5622C15.5468 23.9649 15.3609 24.3985 14.9815 24.5844C14.5169 24.8167 13.9438 24.5844 13.789 24.0965C13.3553 22.7878 13.3321 21.3785 13.7193 20.0388C14.1065 18.6991 14.8886 17.5221 15.9495 16.6548C16.3521 16.3295 16.9484 16.4457 17.2194 16.8871H17.2117Z\" fill=\"#595757\"/>\n      <path d=\"M15.0181 12.2926C15.2659 12.6798 15.1575 13.1831 14.7858 13.4619C12.7492 14.9797 11.3321 17.055 10.581 19.6414C9.82983 22.2278 9.90726 24.7368 10.821 27.1141C10.9836 27.5478 10.8133 28.0279 10.3951 28.2215C9.93824 28.4306 9.40392 28.206 9.22581 27.7336C8.1959 25.0233 8.08748 22.0807 8.9393 19.1613C9.78336 16.2419 11.4483 13.8104 13.7714 12.0758C14.1741 11.7738 14.7471 11.8667 15.0181 12.2926Z\" fill=\"#595757\"/>\n      <path d=\"M32.991 16.8871C32.7742 17.251 32.8439 17.7157 33.1691 17.9789C33.9667 18.6372 34.5475 19.5122 34.8418 20.5189C35.136 21.5256 35.1128 22.5787 34.7876 23.5622C34.6559 23.9649 34.8418 24.3985 35.2212 24.5844C35.6858 24.8167 36.2589 24.5844 36.4137 24.0965C36.8474 22.7878 36.8706 21.3785 36.4834 20.0388C36.0963 18.6991 35.3141 17.5221 34.2532 16.6548C33.8506 16.3295 33.2543 16.4457 32.9833 16.8871H32.991Z\" fill=\"#595757\"/>\n      <path d=\"M34.9821 12.2926C34.7343 12.6798 34.8427 13.1831 35.2144 13.4619C37.251 14.9797 38.6681 17.055 39.4193 19.6414C40.1704 22.2278 40.093 24.7368 39.1792 27.1141C39.0166 27.5478 39.187 28.0279 39.6051 28.2215C40.062 28.4306 40.5963 28.206 40.7744 27.7336C41.8044 25.0233 41.9128 22.0807 41.061 19.1613C40.2169 16.2419 38.552 13.8104 36.2289 12.0758C35.8262 11.7738 35.2532 11.8667 34.9821 12.2926Z\" fill=\"#595757\"/>\n      <path d=\"M24.7416 36.1292C19.484 36.1292 15.1232 32.6468 14.4022 28.137C14.2879 27.439 14.9122 26.8115 15.7034 26.8115C16.3452 26.8115 16.8904 27.2351 16.9871 27.7998C17.5322 31.188 20.8028 33.7919 24.7416 33.7919C28.6804 33.7919 31.9511 31.1801 32.4962 27.7998C32.5841 27.2272 33.1292 26.8115 33.7798 26.8115C34.5711 26.8115 35.1953 27.439 35.081 28.137C34.3601 32.6468 29.9992 36.1292 24.7416 36.1292Z\" fill=\"#DB2D30\"/>\n      <path d=\"M24.7409 30.9531C21.8825 30.9531 19.5645 28.7896 19.5645 26.1217V21.2904C19.5645 18.6225 21.8825 16.459 24.7409 16.459C27.5993 16.459 29.9174 18.6225 29.9174 21.2904V26.1217C29.9174 28.7896 27.5993 30.9531 24.7409 30.9531ZM24.7409 18.8747C23.3117 18.8747 22.1527 19.9564 22.1527 21.2904V26.1217C22.1527 27.4556 23.3117 28.5374 24.7409 28.5374C26.1701 28.5374 27.3292 27.4556 27.3292 26.1217V21.2904C27.3292 19.9564 26.1701 18.8747 24.7409 18.8747Z\" fill=\"#DB2D30\"/>\n      <path d=\"M24.8076 35.0942H24.6751C24.1399 35.0942 23.7061 35.6152 23.7061 36.2579V40.1423C23.7061 40.785 24.1399 41.306 24.6751 41.306H24.8076C25.3428 41.306 25.7766 40.785 25.7766 40.1423V36.2579C25.7766 35.6152 25.3428 35.0942 24.8076 35.0942Z\" fill=\"#DB2D30\"/>\n      <path d=\"M25 47C37.1503 47 47 37.1503 47 25C47 12.8497 37.1503 3 25 3C12.8497 3 3 12.8497 3 25C3 37.1503 12.8497 47 25 47Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g clip-path=\"url(#clip0_3013_2274)\">\n      <path d=\"M21.6381 5.04273V19.6901H8.95225V5.04273H21.6381ZM22.3925 3H8.19783C7.48984 3 6.90952 3.55711 6.90952 4.2535V20.4909C6.90952 21.1757 7.48984 21.7444 8.19783 21.7444H22.3809C23.0889 21.7444 23.6692 21.1873 23.6692 20.4909V4.2535C23.6692 3.56872 23.0889 3 22.3809 3H22.3925Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.545 5.04273V19.6901H27.8591V5.04273H40.545ZM41.2994 3H27.1163C26.4083 3 25.828 3.55711 25.828 4.2535V20.4909C25.828 21.1757 26.4083 21.7444 27.1163 21.7444H41.2994C42.0074 21.7444 42.5877 21.1873 42.5877 20.4909V4.2535C42.5877 3.56872 42.0074 3 41.2994 3Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.5566 24.9138V29.893H8.95225V24.9138H40.5566ZM41.2762 22.8711H8.23265C7.50144 22.8711 6.90952 23.3237 6.90952 23.8809V30.926C6.90952 31.4831 7.50144 31.9357 8.23265 31.9357H41.2762C42.0074 31.9357 42.5993 31.4831 42.5993 30.926V23.8809C42.5993 23.3237 42.0074 22.8711 41.2762 22.8711Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.5566 35.0584V36.0101H8.95225V35.0584H40.5566ZM41.2762 33.0156H8.23265C7.50144 33.0156 6.90952 33.4683 6.90952 34.0254V37.0431C6.90952 37.6002 7.50144 38.0528 8.23265 38.0528H41.2762C42.0074 38.0528 42.5993 37.6002 42.5993 37.0431V34.0254C42.5993 33.4683 42.0074 33.0156 41.2762 33.0156Z\" fill=\"#595757\"/>\n      <path d=\"M42.2047 42.4255L44.5376 44.9441H4.97124L7.30414 42.4255H42.1931M42.5065 40.3828H6.99076C6.61936 40.3828 6.27116 40.5337 6.01582 40.8123L2.34819 44.7817C1.57056 45.6289 2.16248 46.9985 3.32313 46.9985H46.1857C47.3347 46.9985 47.9383 45.6289 47.1606 44.7817L43.493 40.8123C43.2377 40.5453 42.8895 40.3828 42.5181 40.3828H42.5065Z\" fill=\"#595757\"/>\n      </g>\n      <defs>\n      <clipPath id=\"clip0_3013_2274\">\n      <rect width=\"45.5088\" height=\"44\" fill=\"white\" transform=\"translate(2 3)\"/>\n      </clipPath>\n      </defs>\n    </svg>"],
  "item4": ["<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M25 47C37.1462 47 47 37.1462 47 25C47 12.8538 37.1462 3 25 3C12.8538 3 3 12.8449 3 25C3 37.1551 12.8538 47 25 47Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M35.3692 13.458C35.3692 13.458 32.4815 14 30.3224 16.6123C28.3409 19.0469 28.4298 21.2149 28.4298 21.2149\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M24.547 9.49512C24.547 9.49512 22.8321 11.8408 23.1076 15.2617C23.3741 18.416 24.9113 19.9531 24.9113 19.9531\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M13.5469 14.5422C13.5469 14.5422 14.0889 17.43 16.7012 19.5891C19.1357 21.6594 21.3037 21.4817 21.3037 21.4817\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M9.49512 25.178C9.49512 25.178 11.8408 26.8928 15.2617 26.7151C18.416 26.5374 19.9531 25.0002 19.9531 25.0002\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M14.6309 36.3645C14.6309 36.3645 17.5186 35.8225 19.6777 33.2102C21.6591 30.7757 21.5703 28.6077 21.5703 28.6077\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25.4532 40.4162C25.4532 40.4162 27.168 38.0705 26.8926 34.6497C26.626 31.4954 25.0889 29.9583 25.0889 29.9583\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M36.4532 35.3693C36.4532 35.3693 35.9112 32.4815 33.2989 30.3224C30.8643 28.2521 28.6963 28.4298 28.6963 28.4298\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M40.416 24.7337C40.416 24.7337 38.0703 23.0188 34.6494 23.1965C31.4952 23.3742 29.958 24.9114 29.958 24.9114\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25 30.0468C27.79 30.0468 30.0468 27.79 30.0468 25C30.0468 22.21 27.79 19.9531 25 19.9531C22.21 19.9531 19.9531 22.21 19.9531 25C19.9531 27.79 22.21 30.0468 25 30.0468Z\" stroke=\"#DB2D30\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25 40.5048C33.5654 40.5048 40.5048 33.5654 40.5048 25C40.5048 16.4345 33.5654 9.49512 25 9.49512C16.4345 9.49512 9.49512 16.4345 9.49512 25C9.49512 33.5654 16.4345 40.5048 25 40.5048Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M20.5656 19.8188H8.85204C7.66361 19.8188 6.7002 20.7823 6.7002 21.9707V25.1219C6.7002 26.3103 7.66361 27.2738 8.85204 27.2738H20.5656C21.754 27.2738 22.7175 26.3103 22.7175 25.1219V21.9707C22.7175 20.7823 21.754 19.8188 20.5656 19.8188Z\" stroke=\"#DB2D30\" stroke-width=\"1.57\" stroke-miterlimit=\"10\"/>\n      <path d=\"M15.4156 19.6841C15.4156 19.6841 11.0489 23.1144 6.7002 25.2843L15.4156 19.6841Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M15.4156 19.6841C15.4156 19.6841 11.0489 23.1144 6.7002 25.2843\" stroke=\"#DB2D30\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M21.9704 20.0801C21.9704 20.0801 16.2532 24.87 10.2568 27.535L21.9704 20.0801Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M21.9704 20.0801C21.9704 20.0801 16.2532 24.87 10.2568 27.535\" stroke=\"#DB2D30\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M38.5363 19.8188H26.8227C25.6343 19.8188 24.6709 20.7823 24.6709 21.9707V25.1219C24.6709 26.3103 25.6343 27.2738 26.8227 27.2738H38.5363C39.7247 27.2738 40.6882 26.3103 40.6882 25.1219V21.9707C40.6882 20.7823 39.7247 19.8188 38.5363 19.8188Z\" stroke=\"#595757\" stroke-width=\"1.57\" stroke-miterlimit=\"10\"/>\n      <path d=\"M32.0176 19.6841C32.0176 19.6841 36.3843 23.1144 40.733 25.2843L32.0176 19.6841Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M32.0176 19.6841C32.0176 19.6841 36.3843 23.1144 40.733 25.2843\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M25.4629 20.0801C25.4629 20.0801 31.1801 24.87 37.1765 27.535L25.4629 20.0801Z\" fill=\"#E6E6E5\"/>\n      <path d=\"M25.4629 20.0801C25.4629 20.0801 31.1801 24.87 37.1765 27.535\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M39.1309 18.3335H8.23088C6.70432 18.3335 5.4668 19.571 5.4668 21.0976V25.8244C5.4668 27.351 6.70432 28.5885 8.23088 28.5885H39.1309C40.6575 28.5885 41.895 27.351 41.895 25.8244V21.0976C41.895 19.571 40.6575 18.3335 39.1309 18.3335Z\" stroke=\"#595757\" stroke-width=\"1.11\" stroke-miterlimit=\"10\"/>\n      <path d=\"M23.4913 11.9231C24.4908 11.9231 25.3011 11.1129 25.3011 10.1134C25.3011 9.11394 24.4908 8.30371 23.4913 8.30371C22.4919 8.30371 21.6816 9.11394 21.6816 10.1134C21.6816 11.1129 22.4919 11.9231 23.4913 11.9231Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M23.5094 47.0188C35.3887 47.0188 45.0188 37.3887 45.0188 25.5094C45.0188 13.6301 35.3887 4 23.5094 4C11.6301 4 2 13.6301 2 25.5094C2 37.3887 11.6301 47.0188 23.5094 47.0188Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M31.6519 17.1768L40.5712 13.3485C41.6968 12.8653 42.2177 11.5611 41.7345 10.4354L41.4541 9.78217C40.971 8.65651 39.6668 8.13566 38.5411 8.61881L29.6218 12.4471C28.4962 12.9303 27.9753 14.2345 28.4585 15.3602L28.7389 16.0134C29.222 17.1391 30.5262 17.66 31.6519 17.1768Z\" fill=\"#DB2D30\"/>\n      <path d=\"M39.7765 14.0994C41.7867 14.0994 43.4163 12.4698 43.4163 10.4596C43.4163 8.44942 41.7867 6.81982 39.7765 6.81982C37.7663 6.81982 36.1367 8.44942 36.1367 10.4596C36.1367 12.4698 37.7663 14.0994 39.7765 14.0994Z\" fill=\"#DB2D30\"/>\n      <path d=\"M48.9996 7.67315C48.9996 7.67315 42.4593 4.40301 40.2129 9.79637\" stroke=\"#DB2D30\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M42.4019 1C42.4019 1 36.3735 5.1327 40.0038 9.7109\" stroke=\"#DB2D30\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M31.151 16.1853C32.0305 16.1853 32.7434 15.4724 32.7434 14.5929C32.7434 13.7134 32.0305 13.0005 31.151 13.0005C30.2715 13.0005 29.5586 13.7134 29.5586 14.5929C29.5586 15.4724 30.2715 16.1853 31.151 16.1853Z\" stroke=\"white\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M39.777 12.052C40.6565 12.052 41.3694 11.3391 41.3694 10.4596C41.3694 9.58014 40.6565 8.86719 39.777 8.86719C38.8975 8.86719 38.1846 9.58014 38.1846 10.4596C38.1846 11.3391 38.8975 12.052 39.777 12.052Z\" stroke=\"white\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/>\n      <path d=\"M14.1552 48.0004C18.9089 48.0004 22.7626 44.1467 22.7626 39.393C22.7626 34.6393 18.9089 30.7856 14.1552 30.7856C9.4015 30.7856 5.54785 34.6393 5.54785 39.393C5.54785 44.1467 9.4015 48.0004 14.1552 48.0004Z\" fill=\"#F5F5F5\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M33.0986 48.0004C37.8523 48.0004 41.7059 44.1467 41.7059 39.393C41.7059 34.6393 37.8523 30.7856 33.0986 30.7856C28.3449 30.7856 24.4912 34.6393 24.4912 39.393C24.4912 44.1467 28.3449 48.0004 33.0986 48.0004Z\" fill=\"#F5F5F5\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M14.1548 41.6435C15.3432 41.6435 16.3066 40.6801 16.3066 39.4917C16.3066 38.3033 15.3432 37.3398 14.1548 37.3398C12.9663 37.3398 12.0029 38.3033 12.0029 39.4917C12.0029 40.6801 12.9663 41.6435 14.1548 41.6435Z\" fill=\"#595757\"/>\n      <path d=\"M33.0981 41.5444C34.2866 41.5444 35.25 40.581 35.25 39.3926C35.25 38.2041 34.2866 37.2407 33.0981 37.2407C31.9097 37.2407 30.9463 38.2041 30.9463 39.3926C30.9463 40.581 31.9097 41.5444 33.0981 41.5444Z\" fill=\"#595757\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <mask id=\"path-1-inside-1_7029_3735\" fill=\"white\">\n      <rect width=\"12.2857\" height=\"5.43284\" rx=\"2\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 27.9385 14.1025)\"/>\n      </mask>\n      <rect width=\"12.2857\" height=\"5.43284\" rx=\"2\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 27.9385 14.1025)\" stroke=\"#595757\" stroke-width=\"4.2\" mask=\"url(#path-1-inside-1_7029_3735)\"/>\n      <rect x=\"1.13463\" y=\"0.951995\" width=\"46.4549\" height=\"12.113\" rx=\"2.95\" transform=\"matrix(0.995964 -0.0897497 0.0846357 0.996412 -0.0759939 20.322)\" fill=\"white\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n      <path d=\"M42.233 31L45.1758 36.25H39.2902L42.233 31Z\" fill=\"#DB2D30\"/>\n      <path d=\"M49.9999 36H0.485352\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g clip-path=\"url(#clip0_7021_1007)\">\n      <path d=\"M18.734 32.8968C22.4502 32.8968 25.468 29.8799 25.468 26.1583C25.468 22.4367 22.4502 19.4199 18.734 19.4199C15.0178 19.4199 12 22.4367 12 26.1583C12 29.8799 15.0178 32.8968 18.734 32.8968Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n      <path d=\"M18.734 29.5448C20.6051 29.5448 22.1226 28.0321 22.1226 26.1584C22.1226 24.2847 20.6051 22.772 18.734 22.772C16.863 22.772 15.3455 24.2847 15.3455 26.1584C15.3455 28.0321 16.863 29.5448 18.734 29.5448Z\" stroke=\"#595757\" stroke-width=\"1.05\" stroke-miterlimit=\"10\"/>\n      <path d=\"M35.4313 26.8707C36.2246 26.8707 36.8626 26.2261 36.8626 25.4354C36.8626 24.6446 36.2246 24 35.4313 24C34.6381 24 34 24.6446 34 25.4354C34 26.2261 34.6381 26.8707 35.4313 26.8707Z\" fill=\"#EA0029\" stroke=\"#EA0029\" stroke-width=\"1.49\" stroke-miterlimit=\"10\"/>\n      <path d=\"M44.8184 10.9023H5.19031C3.92839 10.9023 2.9054 11.9221 2.9054 13.18V37.4864C2.9054 38.7443 3.92839 39.7641 5.19031 39.7641H44.8184C46.0803 39.7641 47.1033 38.7443 47.1033 37.4864V13.18C47.1033 11.9221 46.0803 10.9023 44.8184 10.9023Z\" stroke=\"#595757\" stroke-width=\"2.1\"/>\n      </g>\n      <defs>\n      <clipPath id=\"clip0_7021_1007\">\n      <rect width=\"46\" height=\"30.6667\" fill=\"white\" transform=\"translate(2 10)\"/>\n      </clipPath>\n      </defs>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M17.2117 16.8871C17.4285 17.251 17.3588 17.7157 17.0336 17.9789C16.236 18.6372 15.6552 19.5122 15.3609 20.5189C15.0667 21.5256 15.0899 22.5787 15.4151 23.5622C15.5468 23.9649 15.3609 24.3985 14.9815 24.5844C14.5169 24.8167 13.9438 24.5844 13.789 24.0965C13.3553 22.7878 13.3321 21.3785 13.7193 20.0388C14.1065 18.6991 14.8886 17.5221 15.9495 16.6548C16.3521 16.3295 16.9484 16.4457 17.2194 16.8871H17.2117Z\" fill=\"#595757\"/>\n      <path d=\"M15.0181 12.2926C15.2659 12.6798 15.1575 13.1831 14.7858 13.4619C12.7492 14.9797 11.3321 17.055 10.581 19.6414C9.82983 22.2278 9.90726 24.7368 10.821 27.1141C10.9836 27.5478 10.8133 28.0279 10.3951 28.2215C9.93824 28.4306 9.40392 28.206 9.22581 27.7336C8.1959 25.0233 8.08748 22.0807 8.9393 19.1613C9.78336 16.2419 11.4483 13.8104 13.7714 12.0758C14.1741 11.7738 14.7471 11.8667 15.0181 12.2926Z\" fill=\"#595757\"/>\n      <path d=\"M32.991 16.8871C32.7742 17.251 32.8439 17.7157 33.1691 17.9789C33.9667 18.6372 34.5475 19.5122 34.8418 20.5189C35.136 21.5256 35.1128 22.5787 34.7876 23.5622C34.6559 23.9649 34.8418 24.3985 35.2212 24.5844C35.6858 24.8167 36.2589 24.5844 36.4137 24.0965C36.8474 22.7878 36.8706 21.3785 36.4834 20.0388C36.0963 18.6991 35.3141 17.5221 34.2532 16.6548C33.8506 16.3295 33.2543 16.4457 32.9833 16.8871H32.991Z\" fill=\"#595757\"/>\n      <path d=\"M34.9821 12.2926C34.7343 12.6798 34.8427 13.1831 35.2144 13.4619C37.251 14.9797 38.6681 17.055 39.4193 19.6414C40.1704 22.2278 40.093 24.7368 39.1792 27.1141C39.0166 27.5478 39.187 28.0279 39.6051 28.2215C40.062 28.4306 40.5963 28.206 40.7744 27.7336C41.8044 25.0233 41.9128 22.0807 41.061 19.1613C40.2169 16.2419 38.552 13.8104 36.2289 12.0758C35.8262 11.7738 35.2532 11.8667 34.9821 12.2926Z\" fill=\"#595757\"/>\n      <path d=\"M24.7416 36.1292C19.484 36.1292 15.1232 32.6468 14.4022 28.137C14.2879 27.439 14.9122 26.8115 15.7034 26.8115C16.3452 26.8115 16.8904 27.2351 16.9871 27.7998C17.5322 31.188 20.8028 33.7919 24.7416 33.7919C28.6804 33.7919 31.9511 31.1801 32.4962 27.7998C32.5841 27.2272 33.1292 26.8115 33.7798 26.8115C34.5711 26.8115 35.1953 27.439 35.081 28.137C34.3601 32.6468 29.9992 36.1292 24.7416 36.1292Z\" fill=\"#DB2D30\"/>\n      <path d=\"M24.7409 30.9531C21.8825 30.9531 19.5645 28.7896 19.5645 26.1217V21.2904C19.5645 18.6225 21.8825 16.459 24.7409 16.459C27.5993 16.459 29.9174 18.6225 29.9174 21.2904V26.1217C29.9174 28.7896 27.5993 30.9531 24.7409 30.9531ZM24.7409 18.8747C23.3117 18.8747 22.1527 19.9564 22.1527 21.2904V26.1217C22.1527 27.4556 23.3117 28.5374 24.7409 28.5374C26.1701 28.5374 27.3292 27.4556 27.3292 26.1217V21.2904C27.3292 19.9564 26.1701 18.8747 24.7409 18.8747Z\" fill=\"#DB2D30\"/>\n      <path d=\"M24.8076 35.0942H24.6751C24.1399 35.0942 23.7061 35.6152 23.7061 36.2579V40.1423C23.7061 40.785 24.1399 41.306 24.6751 41.306H24.8076C25.3428 41.306 25.7766 40.785 25.7766 40.1423V36.2579C25.7766 35.6152 25.3428 35.0942 24.8076 35.0942Z\" fill=\"#DB2D30\"/>\n      <path d=\"M25 47C37.1503 47 47 37.1503 47 25C47 12.8497 37.1503 3 25 3C12.8497 3 3 12.8497 3 25C3 37.1503 12.8497 47 25 47Z\" stroke=\"#595757\" stroke-width=\"2.1\" stroke-miterlimit=\"10\"/>\n    </svg>", "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g clip-path=\"url(#clip0_3013_2274)\">\n      <path d=\"M21.6381 5.04273V19.6901H8.95225V5.04273H21.6381ZM22.3925 3H8.19783C7.48984 3 6.90952 3.55711 6.90952 4.2535V20.4909C6.90952 21.1757 7.48984 21.7444 8.19783 21.7444H22.3809C23.0889 21.7444 23.6692 21.1873 23.6692 20.4909V4.2535C23.6692 3.56872 23.0889 3 22.3809 3H22.3925Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.545 5.04273V19.6901H27.8591V5.04273H40.545ZM41.2994 3H27.1163C26.4083 3 25.828 3.55711 25.828 4.2535V20.4909C25.828 21.1757 26.4083 21.7444 27.1163 21.7444H41.2994C42.0074 21.7444 42.5877 21.1873 42.5877 20.4909V4.2535C42.5877 3.56872 42.0074 3 41.2994 3Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.5566 24.9138V29.893H8.95225V24.9138H40.5566ZM41.2762 22.8711H8.23265C7.50144 22.8711 6.90952 23.3237 6.90952 23.8809V30.926C6.90952 31.4831 7.50144 31.9357 8.23265 31.9357H41.2762C42.0074 31.9357 42.5993 31.4831 42.5993 30.926V23.8809C42.5993 23.3237 42.0074 22.8711 41.2762 22.8711Z\" fill=\"#EA0029\"/>\n      <path d=\"M40.5566 35.0584V36.0101H8.95225V35.0584H40.5566ZM41.2762 33.0156H8.23265C7.50144 33.0156 6.90952 33.4683 6.90952 34.0254V37.0431C6.90952 37.6002 7.50144 38.0528 8.23265 38.0528H41.2762C42.0074 38.0528 42.5993 37.6002 42.5993 37.0431V34.0254C42.5993 33.4683 42.0074 33.0156 41.2762 33.0156Z\" fill=\"#595757\"/>\n      <path d=\"M42.2047 42.4255L44.5376 44.9441H4.97124L7.30414 42.4255H42.1931M42.5065 40.3828H6.99076C6.61936 40.3828 6.27116 40.5337 6.01582 40.8123L2.34819 44.7817C1.57056 45.6289 2.16248 46.9985 3.32313 46.9985H46.1857C47.3347 46.9985 47.9383 45.6289 47.1606 44.7817L43.493 40.8123C43.2377 40.5453 42.8895 40.3828 42.5181 40.3828H42.5065Z\" fill=\"#595757\"/>\n      </g>\n      <defs>\n      <clipPath id=\"clip0_3013_2274\">\n      <rect width=\"45.5088\" height=\"44\" fill=\"white\" transform=\"translate(2 3)\"/>\n      </clipPath>\n      </defs>\n    </svg>"]
});

/***/ }),

/***/ "./src/widgets/ComparisonContainer/index.js":
/*!**************************************************!*\
  !*** ./src/widgets/ComparisonContainer/index.js ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   scrollToElement: function() { return /* binding */ scrollToElement; },
/* harmony export */   updateStickyBlock: function() { return /* binding */ updateStickyBlock; }
/* harmony export */ });
/* harmony import */ var _comparison_container_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./comparison-container.less */ "./src/widgets/ComparisonContainer/comparison-container.less");
/* harmony import */ var _data_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./data.js */ "./src/widgets/ComparisonContainer/data.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");


var ScreenWidth = document.documentElement.clientWidth || window.innerWidth;
var isPhone = ScreenWidth < 750;
$(function () {
  var sectionSettingsScript = document.getElementById('section-settings');
  var sectionSettings = JSON.parse((sectionSettingsScript === null || sectionSettingsScript === void 0 ? void 0 : sectionSettingsScript.textContent) || "{}");

  // 设置虚拟置顶头部
  function generateVirtualHeader(itemData) {
    return "<div class=\"".concat("Qrevo_Edge_Series_", "product-name\"><span>").concat(itemData.product_name, "</span></div>");
  }
  // 设置对比模块内容
  function generateComparisonItem(itemData, index) {
    return "\n      <div class=\"".concat("Qrevo_Edge_Series_", "comparison-block\">\n        <div class=\"").concat("Qrevo_Edge_Series_", "item-image\">\n          <img class=\"").concat("Qrevo_Edge_Series_", "pic1 ").concat("Qrevo_Edge_Series_", "hide-pc\"\n            src=\"").concat(itemData.imgsrc, "\" alt=\"").concat(itemData.alt, "\"/>\n          <img class=\"").concat("Qrevo_Edge_Series_", "pic1 ").concat("Qrevo_Edge_Series_", "hide-mobile\"\n            src=\"").concat(itemData.imgsrc, "\" alt=\"").concat(itemData.alt, "\"/>\n        </div>\n      </div>\n      <!-- \u4EA7\u54C1\u540D\u79F0 -->\n      <h3 class=\"").concat("Qrevo_Edge_Series_", "product-name\"><span>").concat(itemData.product_name, "</span></h3>\n      <!-- \u989C\u8272 -->\n      <div class=\"").concat("Qrevo_Edge_Series_", "comparison-block\">\n        <div class=\"").concat("Qrevo_Edge_Series_", "item-colors\">\n          ").concat(itemData.color_list.split(',').map(function (color) {
      return "<div class=\"".concat("Qrevo_Edge_Series_", "item-color\" style=\"background: ").concat(color, "\"></div>");
    }).join(''), "\n        </div>\n      </div>\n      <!-- buy now -->\n      <div class=\"").concat("Qrevo_Edge_Series_", "comparison-block\">\n        ").concat(getBuyNowButton(itemData), "\n      </div>\n      <!-- \u7EBF\u6761 -->\n      <div class=\"").concat("Qrevo_Edge_Series_", "comparison-block\">\n        <div class=\"").concat("Qrevo_Edge_Series_", "comparison-line\"></div>\n      </div>\n      <!-- \u4EA7\u54C1\u5BF9\u6BD4\u4FE1\u606F -->\n      ").concat(generateComparisonData(itemData, index), "\n    ");
  }

  // 获取产品对比信息
  function generateComparisonData(itemData, num) {
    var iconKey = "item".concat(num);
    return _data_js__WEBPACK_IMPORTED_MODULE_1__["default"][iconKey].map(function (icon, index) {
      var title1 = hasContent(itemData["compare_item".concat(index + 1, "_title1")]);
      var title2 = hasContent(itemData["compare_item".concat(index + 1, "_title2")]);
      var subtitle1 = hasContent(itemData["compare_item".concat(index + 1, "_subtitle1")]);
      var subtitle2 = hasContent(itemData["compare_item".concat(index + 1, "_subtitle2")]);
      var showContent = title1 || title2 || subtitle1 || subtitle2;
      if (showContent) {
        return "\n          <div class=\"".concat("Qrevo_Edge_Series_", "comparison-block ").concat("Qrevo_Edge_Series_", "comparison-gap\">\n            <div class=\"").concat("Qrevo_Edge_Series_", "compare-icon\">\n              ").concat(icon, "\n            </div>\n            <div class=\"").concat("Qrevo_Edge_Series_", "compare-title\">").concat(title1, "</div>\n            <div class=\"").concat("Qrevo_Edge_Series_", "compare-title\">").concat(title2, "</div>\n            <div class=\"").concat("Qrevo_Edge_Series_", "compare-subtitle\">").concat(subtitle1, "</div>\n            <div class=\"").concat("Qrevo_Edge_Series_", "compare-subtitle\">").concat(subtitle2, "</div>\n          </div>  \n        ");
      } else {
        return "<div class=\"".concat("Qrevo_Edge_Series_", "comparison-block ").concat("Qrevo_Edge_Series_", "comparison-gap\">\u2014</div>");
      }
    }).join('');
  }
  // 判断是否有内容
  function hasContent(content) {
    if (content && content != "error" && content != ' ') {
      return content;
    }
    return '';
  }
  // 设置buy now 按钮 
  // <div class="${PREFIXER}buy-now purchase-sales-channel-btn" product-name="${itemData.product_channel}" data-toggle="modal" data-target="#product-sales-channel">Buy Now</div>
  function getBuyNowButton(itemData) {
    if (itemData.btn_text) {
      if (itemData.open_purchase) {
        if (itemData.show_new_channel_compare) {
          return "<button class=\"".concat("Qrevo_Edge_Series_", "buy-now show-product-channel-new\" data-compare-index=\"").concat(itemData.index, "\" v-track-click:buy_now.delegate='{\n                  \"module_name\": \"compare\",\n                  \"product_name\": \"").concat(itemData.product_name, "\",\n                  \"button_name\": \"").concat(itemData.btn_text, "\"\n                }'>\n              ").concat(itemData.btn_text, "</button>");
        } else {
          return "<button class=\"".concat("Qrevo_Edge_Series_", "buy-now purchase-sales-channel-btn\" product-name=\"").concat(itemData.product_channel, "\" data-toggle=\"modal\" data-target=\"#product-sales-channel\">\n              ").concat(itemData.btn_text, "</button>");
        }
      } else {
        return itemData.btn_link ? "<a href=\"".concat(itemData.btn_link, "\"><button class=\"").concat("Qrevo_Edge_Series_", "buy-now\">").concat(itemData.btn_text, "</button></a>") : "<button class=\"".concat("Qrevo_Edge_Series_", "buy-now\">").concat(itemData.btn_text, "</button>");
      }
    } else {
      return '';
    }
  }

  // 填充对比模块 & 置顶头部
  function populateComparisonAreas() {
    var comparisonAreas = document.getElementById('comparison-areas');
    var productListDOM = document.getElementById('product-name-list');
    var htmlContent = '';
    var productVDOM = '';
    var setItemNum = 0; // 设置数量
    var productLen = 4;
    for (var index = 1; index <= productLen; index++) {
      // liquid设置的参数, 仅展示配置为true的模块
      var sectionSettingsItem = sectionSettings["item_".concat(index)];
      if (sectionSettingsItem && sectionSettingsItem.showComparison) {
        htmlContent += generateComparisonItem(sectionSettingsItem, index);
        productVDOM += generateVirtualHeader(sectionSettingsItem);
        setItemNum++;
      }
    }
    // 移动端超过2个修改间距
    if (setItemNum > 2) {
      // 设置布局列数，当前默认是2列
      $($.CN(".comparison-areas")).css('grid-template-columns', "repeat(".concat(setItemNum, ", 1fr)"));
      if (isPhone) {
        $($.CN(".product-name-box")).addClass("".concat("Qrevo_Edge_Series_", "comparison-more"));
        $($.CN(".comparison-areas")).addClass("".concat("Qrevo_Edge_Series_", "comparison-more"));
      }
    }
    if (comparisonAreas) {
      comparisonAreas.innerHTML = htmlContent;
    }
    if (productListDOM) {
      productListDOM.innerHTML = productVDOM;
    }
    setStickyTop();
    // *重新执行销售按钮事件
    typeof ReloadSalesChannelEvents === "function" && ReloadSalesChannelEvents();
  }
  populateComparisonAreas();
  window.onload = function () {
    // 设置粘性布局背景
    updateStickyBlock();
    // 设置滚动交互
    scrollToElement();
  };
});

// 设置背景色以及虚拟节点
function updateStickyBlock() {
  // 设置布局列数，当前默认是2列
  var productNameList = $($.CN(".comparison-container .comparison-areas .product-name"));
  if (!isPhone) return;
  var productName = productNameList[0] || null;
  var comparisonAreas = $($.CN(".comparison-areas"))[0] || null;

  // 模拟菜单块（用于固定顶部）
  var productNameBox = $($.CN(".product-name-box"));
  if (!productNameBox || !productName || !comparisonAreas) return;
  var productNameOffsetTop = productName.offsetTop;
  var productNameOffsetHeight = productName.offsetHeight;
  var comparisonAreasOffsetTop = comparisonAreas.offsetTop;
  var comparisonAreasHeight = comparisonAreas.offsetHeight;

  // 更新背景
  function updateProductNameBackground() {
    var scrollPosition = window.scrollY;
    if (scrollPosition >= productNameOffsetTop - productNameOffsetHeight && scrollPosition < comparisonAreasOffsetTop + comparisonAreasHeight - productNameOffsetHeight) {
      if (!productNameBox.hasClass("".concat("Qrevo_Edge_Series_", "product-name-box-sticky"))) {
        productNameBox.addClass("".concat("Qrevo_Edge_Series_", "product-name-box-sticky"));
      }
    } else {
      if (productNameBox.hasClass("".concat("Qrevo_Edge_Series_", "product-name-box-sticky"))) {
        productNameBox.removeClass("".concat("Qrevo_Edge_Series_", "product-name-box-sticky"));
      }
    }
  }
  window.addEventListener('scroll', updateProductNameBackground);
  updateProductNameBackground();
}

// 设置滚动联动
function scrollToElement() {
  if (!isPhone) return;
  // const productNameList = document.querySelector('#product-name-list');
  var productNameList = document.querySelector('#product-name-box');
  var comparisonAreas = document.querySelector('#comparison-areas');
  if (!productNameList || !comparisonAreas) return;

  // let isScrollingProductNameList = false;
  var isScrollingComparisonAreas = false;
  function syncScroll(target, source, targetMaxScrollLeft) {
    // const targetMaxScrollLeft = target.scrollWidth - target.clientWidth;
    var newScrollLeft = source.scrollLeft;
    if (newScrollLeft <= targetMaxScrollLeft) {
      // target.style.transform = 'translateX(' + -newScrollLeft + 'px)';
      target.scroll({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
    // if (newScrollLeft <= targetMaxScrollLeft && newScrollLeft >= 0) {
    //   target.style.transform = 'translateX(' + -newScrollLeft + 'px)';
    //   // target.scrollLeft = newScrollLeft;
    // } else if (newScrollLeft > targetMaxScrollLeft) {
    //   // target.scrollLeft = targetMaxScrollLeft;
    // } else {
    //   target.style.transform = 'translateX(' + -newScrollLeft + 'px)';
    // }
  }
  // 产品名称滚动
  // function handleProductNameListScroll() {
  //   if (!isScrollingProductNameList) {
  //     isScrollingProductNameList = true;
  //     requestAnimationFrame(() => {
  //       const targetMaxScrollLeft = comparisonAreas.scrollWidth - productNameList.clientWidth;
  //       syncScroll(comparisonAreas, productNameList, targetMaxScrollLeft);
  //       isScrollingProductNameList = false;
  //     });
  //   }
  // }

  // 比较区域滚动
  function handleComparisonAreasScroll() {
    if (!isScrollingComparisonAreas) {
      isScrollingComparisonAreas = true;
      var targetMaxScrollLeft = productNameList.clientWidth;
      requestAnimationFrame(function () {
        syncScroll(productNameList, comparisonAreas, targetMaxScrollLeft);
        isScrollingComparisonAreas = false;
      });
    }
  }
  // productNameList.addEventListener('scroll', handleProductNameListScroll);
  comparisonAreas.addEventListener('scroll', handleComparisonAreasScroll);
}

// 设置置顶位置
function setStickyTop() {
  if (isPhone) {
    var header = document.querySelector('#shopify-section-header .navbar-content');
    var headerGlobal = document.querySelector('#shopify-section-header-global .navbar-content');
    var topbar = document.getElementById('shopify-section-topbar-global');
    var topbarGlobal = document.getElementById('shopify-section-topbar-global');
    var headerHeight = 0;
    var topbarHeight = 0;
    // 获取高度 

    if (header && header.offsetHeight) {
      headerHeight = header.offsetHeight;
    } else if (headerGlobal && headerGlobal.offsetHeight) {
      headerHeight = headerGlobal.offsetHeight;
    }
    if (topbar && topbar.offsetHeight) {
      topbarHeight = topbar.offsetHeight;
    } else if (topbarGlobal && topbarGlobal.offsetHeight) {
      topbarHeight = topbarGlobal.offsetHeight;
    }

    // 计算总高度
    var totalHeight = headerHeight + topbarHeight;

    // 设置定位高度
    $($.CN(".product-name-box")).css('top', "".concat(totalHeight, "px"));
  }
}

/***/ }),

/***/ "./src/widgets/FullScreenVideo/index.js":
/*!**********************************************!*\
  !*** ./src/widgets/FullScreenVideo/index.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./index.less */ "./src/widgets/FullScreenVideo/index.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");
// 一般用于第一屏视频弹窗播放
// 结构为
// 注意IFRAME的地址并没有直接设置，而是记录到data-src上，等实际点击播放按钮，显示弹窗时，才会设置src，进而加载视频
/* <div class="full_screen_video">
    <button type="button" class="video-close modal-close" data-dismiss="modal" aria-label="Close">
      <img class="ico-close"
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAwCAYAAABaHInAAAABDklEQVR42tXYMQrCQBCF4XSpPIJ1TuEFLIQcyXgBwYNYaWcXj5HWMwQV1gGRFRn563/gNcvA7tfkQZrvKaUcynvOkbYRTLxzHZkjt0iXL9SpOAOqzvhvcZfhJKgpskxWAedFMU6MYpwYxTgxinFiFOOcKMadKk6JYpwYxTgHii8eAGdDMU6MYpwYxTgxinFiFOPEKMaJUYxToxjHKCtuAygt7gkoJ86H4k/64wd2wZ4z/ffDKpCipsheiOOegiqworjnxCjGiVGME6MYJ0YxToxinBjFODGKcWIU48QoxolRjBOjGCdGMU6MYpwYxTgxinEOFL9xCzgbinHZ4gpQBtwxW1pErhlKgrtH+s/5C4U57sAr4fYtAAAAAElFTkSuQmCC">
    </button>
    <div class="full_video" role="document">
      <div class="modal-body">
        <div class="embed-responsive embed-responsive-16by9">
          {% comment %} q5eh1AufmCQ {% endcomment %}
          <iframe class="as-youtube-video" id="youtubeVideoFrame"
            data-src="https://www.youtube-nocookie.com/embed/{{ 'ppages.youtubeVideo' | t }}?enablejsapi=1&modestbranding=1&showinfo=0&rel=0&theme=light&color=white&controls=1&disablekb=1"
            allowfullscreen>
          </iframe>
        </div>
      </div>
    </div>
  </div> */

/**
 * 使用
 * import '@/widgets/FullScreenVideo'
 */


function initYoutubevideos() {
  var e = document.querySelectorAll($.CN(".as-youtube-video"));
  if (e.length > 0) {
    $(e[0]).attr("src", $(e[0]).data("src"));
    var t = document.createElement("script");
    t.src = "https://www.youtube.com/iframe_api";
    var n = document.getElementsByTagName("script")[0];
    n.parentNode.insertBefore(t, n);
    var i = [],
      r = function r(e) {
        document.addEventListener("hide.all.modals", function (e) {
          for (var t, n = 0; n < i.length; n++) t = i[n], t.pauseVideo();
        });
      };
    window.onYouTubeIframeAPIReady = function () {
      for (var t = 0; t < e.length; t++) i.push(new window.YT.Player(e[t], {
        events: {
          onReady: r
        }
      }));
    };
  }
}
$(function () {
  //在非生产环境就不要加载youtube视频了，以免卡住影响测试
  if (true) initYoutubevideos();
  function pauseVideo() {
    try {
      $($.CN(".full_screen_video iframe")).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    } catch (e) {}
    window.afterPopupHidden();
  }
  $($.CN("#playVideo")).on("click", function (e) {
    window.afterPopupShown();
    openVideoAnim.play();
  });
  $($.CN(".full_screen_video")).on("click", function (t) {
    pauseVideo();
  });
  $($.CN(".full_screen_video .video-close")).on("click", function (t) {
    pauseVideo();
    openVideoAnim.reverse();
    t.originalEvent.stopImmediatePropagation();
  });

  //gsap 弹出视频 带渐显和一点点上浮效果动画

  var openVideoAnim = gsap.timeline({
    paused: true,
    onStart: function onStart() {
      $($.CN(".full_screen_video")).show();
      $($.CN(".full_screen_video .video")).show();
      $($.CN(".full_screen_video")).addClass("".concat("Qrevo_Edge_Series_", "show"));
    },
    onReverseComplete: function onReverseComplete() {
      $($.CN(".full_screen_video .video")).hide();
      $($.CN(".full_screen_video")).hide();
      $($.CN(".full_screen_video")).removeClass("".concat("Qrevo_Edge_Series_", "show"));
      var e = new window.CustomEvent("hide.all.modals");
      document.dispatchEvent(e);
    }
  }).add(gsap.fromTo($.CN(".full_screen_video"), 0.3, {
    scale: 0.95,
    y: "-2%"
  }, {
    scale: 1,
    y: "0%"
  })).add(gsap.fromTo($.CN(".full_screen_video"), 0.3, {
    opacity: 0
  }, {
    opacity: 1
  }), 0);
});

/***/ }),

/***/ "./src/widgets/ParameterContainer/index.js":
/*!*************************************************!*\
  !*** ./src/widgets/ParameterContainer/index.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   parameterSwiper: function() { return /* binding */ parameterSwiper; }
/* harmony export */ });
/* harmony import */ var _parameter_container_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./parameter-container.less */ "./src/widgets/ParameterContainer/parameter-container.less");

function parameterSwiper() {
  new Swiper("#parameter-swiper", {
    grabCursor: true,
    // speed: 20000,
    // loop: true,
    // slidesPerView: "auto",
    // a11y: { slideRole: "listitem" },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    autoplay: {
      pauseOnMouseEnter: false,
      disableOnInteraction: false,
      delay: 3000
    }
  });
}

/***/ }),

/***/ "./src/widgets/SeriseContainer/index.js":
/*!**********************************************!*\
  !*** ./src/widgets/SeriseContainer/index.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _serise_container_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./serise-container.less */ "./src/widgets/SeriseContainer/serise-container.less");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "jquery");
// 首屏右上角对比组件
// 结构部分
/*
<div id="sideBtn">
    {{ 'ppages.side-btn' | t }}
  </div>
  <section class="serise-container">
    <div class="content">
      <div class="img_box pc">
        <img class="img active" src="{{ 'q7serise_1.jpg' | file_img_url: 'master' }}" alt="">
        <img class="img" src="{{ 'q7serise.jpg' | file_img_url: 'master' }}" alt="">
      </div>
      <div class="img_box mob">
        <img class="img active" src="{{ 'q7serise_1_mob.jpg' | file_img_url: 'master' }}" alt="">
        <img class="img" src="{{ 'q7serise_mob.jpg' | file_img_url: 'master' }}" alt="">
      </div>
      <div class="popup-img"></div>
      <div class="textcont">
        <div class="contbox">
          <div class="title">{{ 'ppages.q7-container.title' | t }}</div>
          <div id="popup-tab" class="tab">
            <div class="tabTitle active" data-pid="0">{{ 'ppages.q7-container.tabTitle1' | t }}</div>
            <div class="tabTitle" data-pid="1">{{ 'ppages.q7-container.tabTitle2' | t }}</div>
          </div>
          <div class="tabbody">
            <div class="tabCard active" data-pid="1">
              {{ 'ppages.q7-container.tabCard1_html' | t }}
            </div>
            <div class="tabCard" data-pid="2">
              {{ 'ppages.q7-container.tabCard2_html' | t }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
*/

$(function () {
  $.extend({
    CN2: function CN2(str) {
      if (str.startsWith('.')) {
        return str.split(' ').map(function (className) {
          if (className.startsWith('.')) {
            return ".".concat("Qrevo_Edge_Series_").concat(className.slice(1));
          } else {
            return className;
          }
        }).join(' ');
      }
      return "Qrevo_Edge_Series_" + str;
    }
  });
  $("#sideBtn").on("click", function () {
    var ele = $($.CN2(".serise-container"));
    ele.hasClass($.CN2("show")) ? ele.addClass($.CN2("hide")).removeClass($.CN2("show")) : ele.addClass($.CN2("show")).removeClass($.CN2("hide"));
  });
  // 首页tab切换
  $("#popup-tab").delegate($.CN2(".tabTitle"), "click", function (e) {
    $(this).addClass($.CN2("active")).siblings().removeClass($.CN2("active"));
    $($.CN2(".tabbody .tabCard")).eq($(this).index()).show().siblings().hide();
    $($.CN2(".pc .img")).eq($(this).index()).addClass($.CN2("active")).siblings().removeClass($.CN2("active"));
    $($.CN2(".mob .img")).eq($(this).index()).addClass($.CN2("active")).siblings().removeClass($.CN2("active"));
  });
});

/***/ }),

/***/ "./src/widgets/index.js":
/*!******************************!*\
  !*** ./src/widgets/index.js ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _SeriseContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./SeriseContainer */ "./src/widgets/SeriseContainer/index.js");
/* harmony import */ var _iconlist_container_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iconlist-container.less */ "./src/widgets/iconlist-container.less");
/* harmony import */ var _dimensions_container_less__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./dimensions-container.less */ "./src/widgets/dimensions-container.less");
/* harmony import */ var _email_container_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./email-container.less */ "./src/widgets/email-container.less");
/* harmony import */ var _notes_container_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./notes-container.less */ "./src/widgets/notes-container.less");
/* harmony import */ var _ComparisonContainer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ComparisonContainer */ "./src/widgets/ComparisonContainer/index.js");
/* harmony import */ var _ParameterContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ParameterContainer */ "./src/widgets/ParameterContainer/index.js");
/**
 * Widget一般是在具体被使用的section里去引用。这里只会引入全局使用的widget，比如用于左侧的导航LeftNav，右上角的对比Serise
 */






// import "./ContrastContainer";



(0,_ParameterContainer__WEBPACK_IMPORTED_MODULE_6__.parameterSwiper)();

/***/ }),

/***/ "./src/assets/styles/common.less":
/*!***************************************!*\
  !*** ./src/assets/styles/common.less ***!
  \***************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/assets/styles/inter-et.less":
/*!*****************************************!*\
  !*** ./src/assets/styles/inter-et.less ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/i18n/index.less":
/*!*****************************!*\
  !*** ./src/i18n/index.less ***!
  \*****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section1/index.less":
/*!******************************************!*\
  !*** ./src/sections/section1/index.less ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section10/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section10/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section11/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section11/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section12/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section12/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section13/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section13/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section14/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section14/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section15/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section15/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section16-expand/index.less":
/*!**************************************************!*\
  !*** ./src/sections/section16-expand/index.less ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section16/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section16/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section17/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section17/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section18/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section18/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section19/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section19/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section2/index.less":
/*!******************************************!*\
  !*** ./src/sections/section2/index.less ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section20/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section20/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section21/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section21/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section23/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section23/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section24/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section24/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section25/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section25/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section26/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section26/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section27/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section27/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section28/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section28/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section29/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section29/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section3/index.less":
/*!******************************************!*\
  !*** ./src/sections/section3/index.less ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section35/index.less":
/*!*******************************************!*\
  !*** ./src/sections/section35/index.less ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section5/index.less":
/*!******************************************!*\
  !*** ./src/sections/section5/index.less ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section7/index.less":
/*!******************************************!*\
  !*** ./src/sections/section7/index.less ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sections/section8/index.less":
/*!******************************************!*\
  !*** ./src/sections/section8/index.less ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/widgets/Album/index.less":
/*!**************************************!*\
  !*** ./src/widgets/Album/index.less ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/widgets/ComparisonContainer/comparison-container.less":
/*!*******************************************************************!*\
  !*** ./src/widgets/ComparisonContainer/comparison-container.less ***!
  \*******************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/widgets/FullScreenVideo/index.less":
/*!************************************************!*\
  !*** ./src/widgets/FullScreenVideo/index.less ***!
  \************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/widgets/ParameterContainer/parameter-container.less":
/*!*****************************************************************!*\
  !*** ./src/widgets/ParameterContainer/parameter-container.less ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/widgets/SeriseContainer/serise-container.less":
/*!***********************************************************!*\
  !*** ./src/widgets/SeriseContainer/serise-container.less ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/widgets/dimensions-container.less":
/*!***********************************************!*\
  !*** ./src/widgets/dimensions-container.less ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/widgets/email-container.less":
/*!******************************************!*\
  !*** ./src/widgets/email-container.less ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/widgets/iconlist-container.less":
/*!*********************************************!*\
  !*** ./src/widgets/iconlist-container.less ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/widgets/notes-container.less":
/*!******************************************!*\
  !*** ./src/widgets/notes-container.less ***!
  \******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "jquery":
/*!********************!*\
  !*** external "$" ***!
  \********************/
/***/ (function(module) {

module.exports = $;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _assets_styles_common_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./assets/styles/common.less */ "./src/assets/styles/common.less");
/* harmony import */ var _assets_js_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assets/js/common */ "./src/assets/js/common.js");
/* harmony import */ var _widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./widgets */ "./src/widgets/index.js");
/* harmony import */ var _sections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./sections */ "./src/sections/index.js");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./i18n */ "./src/i18n/index.js");
/* harmony import */ var _assets_styles_inter_all_less__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./assets/styles/inter-all.less */ "./src/assets/styles/inter-et.less");






/******/ })()
;